// Comprehensive Ciudad del Este Brands Catalog
// Extracted from official Compras Paraguai brands directory (https://comprasparaguai.com.br/marcas/)

export interface BrandItem {
  name: string;
  slug: string;
  firstLetter: string;
  featured?: boolean;
}

export const ALL_CDE_BRANDS: BrandItem[] = [
  {
    "name": "Luxor",
    "slug": "luxor",
    "firstLetter": "L"
  },
  {
    "name": "Joog",
    "slug": "joog",
    "firstLetter": "J"
  },
  {
    "name": "Nintendo",
    "slug": "nintendo",
    "firstLetter": "N"
  },
  {
    "name": "Microsoft",
    "slug": "microsoft",
    "firstLetter": "M"
  },
  {
    "name": "Adidas",
    "slug": "adidas",
    "firstLetter": "A"
  },
  {
    "name": "Hydrant",
    "slug": "hydrant",
    "firstLetter": "H"
  },
  {
    "name": "Lattafa",
    "slug": "lattafa",
    "firstLetter": "L"
  },
  {
    "name": "Paco Rabanne",
    "slug": "paco-rabanne",
    "firstLetter": "P"
  },
  {
    "name": "JBL",
    "slug": "jbl",
    "firstLetter": "J"
  },
  {
    "name": "Canon",
    "slug": "canon",
    "firstLetter": "C"
  },
  {
    "name": "Brand Collection",
    "slug": "brand-collection",
    "firstLetter": "B"
  },
  {
    "name": "Fragrance World",
    "slug": "fragrance-world",
    "firstLetter": "F"
  },
  {
    "name": "Apple",
    "slug": "apple",
    "firstLetter": "A"
  },
  {
    "name": "Samsung",
    "slug": "samsung",
    "firstLetter": "S"
  },
  {
    "name": "Xiaomi",
    "slug": "xiaomi",
    "firstLetter": "X"
  },
  {
    "name": "1800",
    "slug": "1800",
    "firstLetter": "0-9"
  },
  {
    "name": "1More",
    "slug": "1more",
    "firstLetter": "0-9"
  },
  {
    "name": "3COM",
    "slug": "3com",
    "firstLetter": "0-9"
  },
  {
    "name": "3DR",
    "slug": "3dr",
    "firstLetter": "0-9"
  },
  {
    "name": "3nStar",
    "slug": "3nstar",
    "firstLetter": "0-9"
  },
  {
    "name": "4711",
    "slug": "4711",
    "firstLetter": "0-9"
  },
  {
    "name": "4life",
    "slug": "4life",
    "firstLetter": "0-9"
  },
  {
    "name": "5.11 Tactical",
    "slug": "511-tactical",
    "firstLetter": "0-9"
  },
  {
    "name": "Aalto",
    "slug": "aalto",
    "firstLetter": "A"
  },
  {
    "name": "ABC",
    "slug": "abc",
    "firstLetter": "A"
  },
  {
    "name": "Abercrombie & Fitch",
    "slug": "abercrombie-fitch",
    "firstLetter": "A"
  },
  {
    "name": "Abib",
    "slug": "abib",
    "firstLetter": "A"
  },
  {
    "name": "Abrasado",
    "slug": "abrasado",
    "firstLetter": "A"
  },
  {
    "name": "Absolut",
    "slug": "absolut",
    "firstLetter": "A"
  },
  {
    "name": "Abu Garcia",
    "slug": "abu-garcia",
    "firstLetter": "A"
  },
  {
    "name": "Abxylute",
    "slug": "abxylute",
    "firstLetter": "A"
  },
  {
    "name": "AC/DC",
    "slug": "acdc",
    "firstLetter": "A"
  },
  {
    "name": "Accubanker",
    "slug": "accubanker",
    "firstLetter": "A"
  },
  {
    "name": "Acefast",
    "slug": "acefast",
    "firstLetter": "A"
  },
  {
    "name": "Acemagic",
    "slug": "acemagic",
    "firstLetter": "A"
  },
  {
    "name": "Acer",
    "slug": "acer",
    "firstLetter": "A"
  },
  {
    "name": "Acoustic Research",
    "slug": "acoustic-research",
    "firstLetter": "A"
  },
  {
    "name": "Acqua Di Parma",
    "slug": "acqua-di-parma",
    "firstLetter": "A"
  },
  {
    "name": "Acquadì",
    "slug": "acquadi",
    "firstLetter": "A"
  },
  {
    "name": "Ada Tina",
    "slug": "ada-tina",
    "firstLetter": "A"
  },
  {
    "name": "Adak",
    "slug": "adak",
    "firstLetter": "A"
  },
  {
    "name": "Adata",
    "slug": "adata",
    "firstLetter": "A"
  },
  {
    "name": "Adjust",
    "slug": "adjust",
    "firstLetter": "A"
  },
  {
    "name": "Adyan",
    "slug": "adyan",
    "firstLetter": "A"
  },
  {
    "name": "Afnan",
    "slug": "afnan",
    "firstLetter": "A"
  },
  {
    "name": "Afox",
    "slug": "afox",
    "firstLetter": "A"
  },
  {
    "name": "Afterglow",
    "slug": "afterglow",
    "firstLetter": "A"
  },
  {
    "name": "AfterShokz",
    "slug": "aftershokz",
    "firstLetter": "A"
  },
  {
    "name": "Agatha",
    "slug": "agatha",
    "firstLetter": "A"
  },
  {
    "name": "Agatha Ruiz De La Prada",
    "slug": "agatha-ruiz-de-la-prada",
    "firstLetter": "A"
  },
  {
    "name": "AgfaPhoto",
    "slug": "agfaphoto",
    "firstLetter": "A"
  },
  {
    "name": "Agl",
    "slug": "agl",
    "firstLetter": "A"
  },
  {
    "name": "AGM",
    "slug": "agm",
    "firstLetter": "A"
  },
  {
    "name": "Aguila",
    "slug": "aguila",
    "firstLetter": "A"
  },
  {
    "name": "AGV",
    "slug": "agv",
    "firstLetter": "A"
  },
  {
    "name": "Aigo",
    "slug": "aigo",
    "firstLetter": "A"
  },
  {
    "name": "Aikon",
    "slug": "aikon",
    "firstLetter": "A"
  },
  {
    "name": "Aiper",
    "slug": "aiper",
    "firstLetter": "A"
  },
  {
    "name": "Aiptek",
    "slug": "aiptek",
    "firstLetter": "A"
  },
  {
    "name": "Air Live",
    "slug": "air-live",
    "firstLetter": "A"
  },
  {
    "name": "Airoh",
    "slug": "airoh",
    "firstLetter": "A"
  },
  {
    "name": "Aiwa",
    "slug": "aiwa",
    "firstLetter": "A"
  },
  {
    "name": "Ajmal",
    "slug": "ajmal",
    "firstLetter": "A"
  },
  {
    "name": "Ajunbee",
    "slug": "ajunbee",
    "firstLetter": "A"
  },
  {
    "name": "Ajyad",
    "slug": "ajyad",
    "firstLetter": "A"
  },
  {
    "name": "Akaso",
    "slug": "akaso",
    "firstLetter": "A"
  },
  {
    "name": "AKG",
    "slug": "akg",
    "firstLetter": "A"
  },
  {
    "name": "Al Absar",
    "slug": "al-absar",
    "firstLetter": "A"
  },
  {
    "name": "Al Ambra",
    "slug": "al-ambra",
    "firstLetter": "A"
  },
  {
    "name": "Al Fares",
    "slug": "al-fares",
    "firstLetter": "A"
  },
  {
    "name": "Al Gazal",
    "slug": "al-gazal",
    "firstLetter": "A"
  },
  {
    "name": "Al Haramain",
    "slug": "al-haramain",
    "firstLetter": "A"
  },
  {
    "name": "Al Malakia",
    "slug": "al-malakia",
    "firstLetter": "A"
  },
  {
    "name": "Al Qusay",
    "slug": "al-qusay",
    "firstLetter": "A"
  },
  {
    "name": "Al Wataniah",
    "slug": "al-wataniah",
    "firstLetter": "A"
  },
  {
    "name": "Al-A'Raaf",
    "slug": "al-araaf",
    "firstLetter": "A"
  },
  {
    "name": "Alamo",
    "slug": "alamo",
    "firstLetter": "A"
  },
  {
    "name": "Alamos",
    "slug": "alamos",
    "firstLetter": "A"
  },
  {
    "name": "Albane",
    "slug": "albane",
    "firstLetter": "A"
  },
  {
    "name": "Alcatel",
    "slug": "alcatel",
    "firstLetter": "A"
  },
  {
    "name": "ALD",
    "slug": "ald",
    "firstLetter": "A"
  },
  {
    "name": "Alejandro Sanz",
    "slug": "alejandro-sanz",
    "firstLetter": "A"
  },
  {
    "name": "Alesis",
    "slug": "alesis",
    "firstLetter": "A"
  },
  {
    "name": "Alexandre.J",
    "slug": "alexandrej",
    "firstLetter": "A"
  },
  {
    "name": "Alfa Romeo",
    "slug": "alfa-romeo",
    "firstLetter": "A"
  },
  {
    "name": "Alfaparf",
    "slug": "alfaparf",
    "firstLetter": "A"
  },
  {
    "name": "Alhambra",
    "slug": "alhambra",
    "firstLetter": "A"
  },
  {
    "name": "Alien",
    "slug": "alien",
    "firstLetter": "A"
  },
  {
    "name": "Alienware",
    "slug": "alienware",
    "firstLetter": "A"
  },
  {
    "name": "Align",
    "slug": "align",
    "firstLetter": "A"
  },
  {
    "name": "AllWays",
    "slug": "allways",
    "firstLetter": "A"
  },
  {
    "name": "Alma Negra",
    "slug": "alma-negra",
    "firstLetter": "A"
  },
  {
    "name": "Almas",
    "slug": "almas",
    "firstLetter": "A"
  },
  {
    "name": "Alpha Theta",
    "slug": "alpha-theta",
    "firstLetter": "A"
  },
  {
    "name": "Alphaplay",
    "slug": "alphaplay",
    "firstLetter": "A"
  },
  {
    "name": "Alphasat",
    "slug": "alphasat",
    "firstLetter": "A"
  },
  {
    "name": "Alphasonik",
    "slug": "alphasonik",
    "firstLetter": "A"
  },
  {
    "name": "Alpine",
    "slug": "alpine",
    "firstLetter": "A"
  },
  {
    "name": "Altec",
    "slug": "altec",
    "firstLetter": "A"
  },
  {
    "name": "Alviero Martini",
    "slug": "alviero-martini",
    "firstLetter": "A"
  },
  {
    "name": "Amaran",
    "slug": "amaran",
    "firstLetter": "A"
  },
  {
    "name": "Amarula",
    "slug": "amarula",
    "firstLetter": "A"
  },
  {
    "name": "Amazon",
    "slug": "amazon",
    "firstLetter": "A"
  },
  {
    "name": "Ambrosoli",
    "slug": "ambrosoli",
    "firstLetter": "A"
  },
  {
    "name": "AMD",
    "slug": "amd",
    "firstLetter": "A"
  },
  {
    "name": "Amenews",
    "slug": "amenews",
    "firstLetter": "A"
  },
  {
    "name": "Amercook",
    "slug": "amercook",
    "firstLetter": "A"
  },
  {
    "name": "America Box",
    "slug": "america-box",
    "firstLetter": "A"
  },
  {
    "name": "Amouage",
    "slug": "amouage",
    "firstLetter": "A"
  },
  {
    "name": "Ampeg",
    "slug": "ampeg",
    "firstLetter": "A"
  },
  {
    "name": "Ana Hickmann",
    "slug": "ana-hickmann",
    "firstLetter": "A"
  },
  {
    "name": "Anbernic",
    "slug": "anbernic",
    "firstLetter": "A"
  },
  {
    "name": "Andeluna",
    "slug": "andeluna",
    "firstLetter": "A"
  },
  {
    "name": "Andis",
    "slug": "andis",
    "firstLetter": "A"
  },
  {
    "name": "Anfar",
    "slug": "anfar",
    "firstLetter": "A"
  },
  {
    "name": "Angelica Zapata",
    "slug": "angelica-zapata",
    "firstLetter": "A"
  },
  {
    "name": "Animale",
    "slug": "animale",
    "firstLetter": "A"
  },
  {
    "name": "Anker",
    "slug": "anker",
    "firstLetter": "A"
  },
  {
    "name": "Anne Klein",
    "slug": "anne-klein",
    "firstLetter": "A"
  },
  {
    "name": "Another Sexy",
    "slug": "another-sexy",
    "firstLetter": "A"
  },
  {
    "name": "Anthbot",
    "slug": "anthbot",
    "firstLetter": "A"
  },
  {
    "name": "Antonio Banderas",
    "slug": "antonio-banderas",
    "firstLetter": "A"
  },
  {
    "name": "Antonio Puig",
    "slug": "antonio-puig",
    "firstLetter": "A"
  },
  {
    "name": "Anua",
    "slug": "anua",
    "firstLetter": "A"
  },
  {
    "name": "Anyvape",
    "slug": "anyvape",
    "firstLetter": "A"
  },
  {
    "name": "AOC",
    "slug": "aoc",
    "firstLetter": "A"
  },
  {
    "name": "Aochuan",
    "slug": "aochuan",
    "firstLetter": "A"
  },
  {
    "name": "APC",
    "slug": "apc",
    "firstLetter": "A"
  },
  {
    "name": "Ape",
    "slug": "ape",
    "firstLetter": "A"
  },
  {
    "name": "Aperol",
    "slug": "aperol",
    "firstLetter": "A"
  },
  {
    "name": "Appolo",
    "slug": "appolo",
    "firstLetter": "A"
  },
  {
    "name": "APS",
    "slug": "aps",
    "firstLetter": "A"
  },
  {
    "name": "Aputure",
    "slug": "aputure",
    "firstLetter": "A"
  },
  {
    "name": "Aramios",
    "slug": "aramios",
    "firstLetter": "A"
  },
  {
    "name": "Arcor",
    "slug": "arcor",
    "firstLetter": "A"
  },
  {
    "name": "Ard Al Zaafaran",
    "slug": "ard-al-zaafaran",
    "firstLetter": "A"
  },
  {
    "name": "Aresti",
    "slug": "aresti",
    "firstLetter": "A"
  },
  {
    "name": "Argento",
    "slug": "argento",
    "firstLetter": "A"
  },
  {
    "name": "Argom",
    "slug": "argom",
    "firstLetter": "A"
  },
  {
    "name": "Ariana Grande",
    "slug": "ariana-grande",
    "firstLetter": "A"
  },
  {
    "name": "Ariaz",
    "slug": "ariaz",
    "firstLetter": "A"
  },
  {
    "name": "Aris",
    "slug": "aris",
    "firstLetter": "A"
  },
  {
    "name": "Arktek",
    "slug": "arktek",
    "firstLetter": "A"
  },
  {
    "name": "Arlyn",
    "slug": "arlyn",
    "firstLetter": "A"
  },
  {
    "name": "Armaf",
    "slug": "armaf",
    "firstLetter": "A"
  },
  {
    "name": "Armand Basi",
    "slug": "armand-basi",
    "firstLetter": "A"
  },
  {
    "name": "Arnaud",
    "slug": "arnaud",
    "firstLetter": "A"
  },
  {
    "name": "Arnette",
    "slug": "arnette",
    "firstLetter": "A"
  },
  {
    "name": "Arqus",
    "slug": "arqus",
    "firstLetter": "A"
  },
  {
    "name": "Arrogance",
    "slug": "arrogance",
    "firstLetter": "A"
  },
  {
    "name": "Artcom",
    "slug": "artcom",
    "firstLetter": "A"
  },
  {
    "name": "Aryan",
    "slug": "aryan",
    "firstLetter": "A"
  },
  {
    "name": "Asdaaf",
    "slug": "asdaaf",
    "firstLetter": "A"
  },
  {
    "name": "Asics",
    "slug": "asics",
    "firstLetter": "A"
  },
  {
    "name": "Aspire",
    "slug": "aspire",
    "firstLetter": "A"
  },
  {
    "name": "Asrock",
    "slug": "asrock",
    "firstLetter": "A"
  },
  {
    "name": "Assala Prime",
    "slug": "assala-prime",
    "firstLetter": "A"
  },
  {
    "name": "Asten",
    "slug": "asten",
    "firstLetter": "A"
  },
  {
    "name": "Asus",
    "slug": "asus",
    "firstLetter": "A"
  },
  {
    "name": "Asustor",
    "slug": "asustor",
    "firstLetter": "A"
  },
  {
    "name": "Atari",
    "slug": "atari",
    "firstLetter": "A"
  },
  {
    "name": "Athomics",
    "slug": "athomics",
    "firstLetter": "A"
  },
  {
    "name": "Atouch",
    "slug": "atouch",
    "firstLetter": "A"
  },
  {
    "name": "Attack Shark",
    "slug": "attack-shark",
    "firstLetter": "A"
  },
  {
    "name": "Atto",
    "slug": "atto",
    "firstLetter": "A"
  },
  {
    "name": "ATV",
    "slug": "atv",
    "firstLetter": "A"
  },
  {
    "name": "Audio-Technica",
    "slug": "audio-technica",
    "firstLetter": "A"
  },
  {
    "name": "Audisat",
    "slug": "audisat",
    "firstLetter": "A"
  },
  {
    "name": "Auraa Desire",
    "slug": "auraa-desire",
    "firstLetter": "A"
  },
  {
    "name": "Aurora Scents",
    "slug": "aurora-scents",
    "firstLetter": "A"
  },
  {
    "name": "Aussie",
    "slug": "aussie",
    "firstLetter": "A"
  },
  {
    "name": "Australian Gold",
    "slug": "australian-gold",
    "firstLetter": "A"
  },
  {
    "name": "Autel Robotics",
    "slug": "autel-robotics",
    "firstLetter": "A"
  },
  {
    "name": "Aux",
    "slug": "aux",
    "firstLetter": "A"
  },
  {
    "name": "Avanti",
    "slug": "avanti",
    "firstLetter": "A"
  },
  {
    "name": "Avar Collection",
    "slug": "avar-collection",
    "firstLetter": "A"
  },
  {
    "name": "Avec Creations",
    "slug": "avec-creations",
    "firstLetter": "A"
  },
  {
    "name": "Axis",
    "slug": "axis",
    "firstLetter": "A"
  },
  {
    "name": "Axxis",
    "slug": "axxis",
    "firstLetter": "A"
  },
  {
    "name": "Ayelet",
    "slug": "ayelet",
    "firstLetter": "A"
  },
  {
    "name": "Az-America",
    "slug": "az-america",
    "firstLetter": "A"
  },
  {
    "name": "Azha",
    "slug": "azha",
    "firstLetter": "A"
  },
  {
    "name": "Azza",
    "slug": "azza",
    "firstLetter": "A"
  },
  {
    "name": "Azzaro",
    "slug": "azzaro",
    "firstLetter": "A"
  },
  {
    "name": "B-Bomber",
    "slug": "b-bomber",
    "firstLetter": "B"
  },
  {
    "name": "B.Buster",
    "slug": "bbuster",
    "firstLetter": "B"
  },
  {
    "name": "Babolat",
    "slug": "babolat",
    "firstLetter": "B"
  },
  {
    "name": "Babycakes",
    "slug": "babycakes",
    "firstLetter": "B"
  },
  {
    "name": "BaBylissPRO",
    "slug": "babylisspro",
    "firstLetter": "B"
  },
  {
    "name": "Bacardi",
    "slug": "bacardi",
    "firstLetter": "B"
  },
  {
    "name": "Baileys",
    "slug": "baileys",
    "firstLetter": "B"
  },
  {
    "name": "BAK",
    "slug": "bak",
    "firstLetter": "B"
  },
  {
    "name": "Balbás",
    "slug": "balbas",
    "firstLetter": "B"
  },
  {
    "name": "Baldessarini",
    "slug": "baldessarini",
    "firstLetter": "B"
  },
  {
    "name": "Ballantine's",
    "slug": "ballantines",
    "firstLetter": "B"
  },
  {
    "name": "BalMy",
    "slug": "balmy",
    "firstLetter": "B"
  },
  {
    "name": "Baly",
    "slug": "baly",
    "firstLetter": "B"
  },
  {
    "name": "Balzano",
    "slug": "balzano",
    "firstLetter": "B"
  },
  {
    "name": "Bambu Lab",
    "slug": "bambu-lab",
    "firstLetter": "B"
  },
  {
    "name": "Ban",
    "slug": "ban",
    "firstLetter": "B"
  },
  {
    "name": "Banana Boat",
    "slug": "banana-boat",
    "firstLetter": "B"
  },
  {
    "name": "Banana Republic",
    "slug": "banana-republic",
    "firstLetter": "B"
  },
  {
    "name": "Baofeng",
    "slug": "baofeng",
    "firstLetter": "B"
  },
  {
    "name": "Barbasol",
    "slug": "barbasol",
    "firstLetter": "B"
  },
  {
    "name": "Bardinet",
    "slug": "bardinet",
    "firstLetter": "B"
  },
  {
    "name": "Barefoot",
    "slug": "barefoot",
    "firstLetter": "B"
  },
  {
    "name": "Barkleys",
    "slug": "barkleys",
    "firstLetter": "B"
  },
  {
    "name": "Baseus",
    "slug": "baseus",
    "firstLetter": "B"
  },
  {
    "name": "Basso",
    "slug": "basso",
    "firstLetter": "B"
  },
  {
    "name": "Bauducco",
    "slug": "bauducco",
    "firstLetter": "B"
  },
  {
    "name": "Bayanegra",
    "slug": "bayanegra",
    "firstLetter": "B"
  },
  {
    "name": "Bazooka",
    "slug": "bazooka",
    "firstLetter": "B"
  },
  {
    "name": "Be Quiet!",
    "slug": "be-quiet",
    "firstLetter": "B"
  },
  {
    "name": "Beats By Dre",
    "slug": "beats",
    "firstLetter": "B"
  },
  {
    "name": "Beautik",
    "slug": "beautik",
    "firstLetter": "B"
  },
  {
    "name": "Bebe",
    "slug": "bebe",
    "firstLetter": "B"
  },
  {
    "name": "Bed Head",
    "slug": "bed-head",
    "firstLetter": "B"
  },
  {
    "name": "Bee Electrics",
    "slug": "bee-electrics",
    "firstLetter": "B"
  },
  {
    "name": "Beefeater",
    "slug": "beefeater",
    "firstLetter": "B"
  },
  {
    "name": "Beelink",
    "slug": "beelink",
    "firstLetter": "B"
  },
  {
    "name": "Behringer",
    "slug": "behringer",
    "firstLetter": "B"
  },
  {
    "name": "Belgian",
    "slug": "belgian",
    "firstLetter": "B"
  },
  {
    "name": "Belkin",
    "slug": "belkin",
    "firstLetter": "B"
  },
  {
    "name": "Beluga",
    "slug": "beluga",
    "firstLetter": "B"
  },
  {
    "name": "Belvedere",
    "slug": "belvedere",
    "firstLetter": "B"
  },
  {
    "name": "Bematech",
    "slug": "bematech",
    "firstLetter": "B"
  },
  {
    "name": "Benetton",
    "slug": "benetton",
    "firstLetter": "B"
  },
  {
    "name": "Benmax",
    "slug": "benmax",
    "firstLetter": "B"
  },
  {
    "name": "BenQ",
    "slug": "benq",
    "firstLetter": "B"
  },
  {
    "name": "Benro",
    "slug": "benro",
    "firstLetter": "B"
  },
  {
    "name": "Bentley",
    "slug": "bentley",
    "firstLetter": "B"
  },
  {
    "name": "Berbau",
    "slug": "berbau",
    "firstLetter": "B"
  },
  {
    "name": "Berlinger",
    "slug": "berlinger",
    "firstLetter": "B"
  },
  {
    "name": "Bertoni",
    "slug": "bertoni",
    "firstLetter": "B"
  },
  {
    "name": "Bespoke",
    "slug": "bespoke",
    "firstLetter": "B"
  },
  {
    "name": "Best",
    "slug": "best",
    "firstLetter": "B"
  },
  {
    "name": "BetaFPV",
    "slug": "betafpv",
    "firstLetter": "B"
  },
  {
    "name": "Betty Cora",
    "slug": "betty-cora",
    "firstLetter": "B"
  },
  {
    "name": "Beurer",
    "slug": "beurer",
    "firstLetter": "B"
  },
  {
    "name": "Beverly Hills Polo Club",
    "slug": "beverly-hills-polo-club",
    "firstLetter": "B"
  },
  {
    "name": "Beyonce",
    "slug": "beyonce",
    "firstLetter": "B"
  },
  {
    "name": "Bharara",
    "slug": "bharara",
    "firstLetter": "B"
  },
  {
    "name": "Bid",
    "slug": "bid",
    "firstLetter": "B"
  },
  {
    "name": "Bidaya",
    "slug": "bidaya",
    "firstLetter": "B"
  },
  {
    "name": "Bigelow",
    "slug": "bigelow",
    "firstLetter": "B"
  },
  {
    "name": "Billie Eilish",
    "slug": "billie-eilish",
    "firstLetter": "B"
  },
  {
    "name": "Binggrae",
    "slug": "binggrae",
    "firstLetter": "B"
  },
  {
    "name": "Bio Balance",
    "slug": "bio-balance",
    "firstLetter": "B"
  },
  {
    "name": "Bioderma",
    "slug": "bioderma",
    "firstLetter": "B"
  },
  {
    "name": "Biostar",
    "slug": "biostar",
    "firstLetter": "B"
  },
  {
    "name": "Birra Moretti",
    "slug": "birra-moretti",
    "firstLetter": "B"
  },
  {
    "name": "Bitmain",
    "slug": "bitmain",
    "firstLetter": "B"
  },
  {
    "name": "BKR",
    "slug": "bkr",
    "firstLetter": "B"
  },
  {
    "name": "Black & Decker",
    "slug": "black-decker",
    "firstLetter": "B"
  },
  {
    "name": "Black & White",
    "slug": "black-white",
    "firstLetter": "B"
  },
  {
    "name": "Black Shark",
    "slug": "black-shark",
    "firstLetter": "B"
  },
  {
    "name": "BlackBox",
    "slug": "blackbox",
    "firstLetter": "B"
  },
  {
    "name": "Blackmagic",
    "slug": "blackmagic",
    "firstLetter": "B"
  },
  {
    "name": "Blackview",
    "slug": "blackview",
    "firstLetter": "B"
  },
  {
    "name": "Blade",
    "slug": "blade",
    "firstLetter": "B"
  },
  {
    "name": "Blauer",
    "slug": "blauer",
    "firstLetter": "B"
  },
  {
    "name": "Blaupunkt",
    "slug": "blaupunkt",
    "firstLetter": "B"
  },
  {
    "name": "Blenders",
    "slug": "blenders",
    "firstLetter": "B"
  },
  {
    "name": "BLG",
    "slug": "blg",
    "firstLetter": "B"
  },
  {
    "name": "Blu",
    "slug": "blu",
    "firstLetter": "B"
  },
  {
    "name": "Bluboo",
    "slug": "bluboo",
    "firstLetter": "B"
  },
  {
    "name": "Bluetti",
    "slug": "bluetti",
    "firstLetter": "B"
  },
  {
    "name": "Bluhan",
    "slug": "bluhan",
    "firstLetter": "B"
  },
  {
    "name": "Blulory",
    "slug": "blulory",
    "firstLetter": "B"
  },
  {
    "name": "Blumarine",
    "slug": "blumarine",
    "firstLetter": "B"
  },
  {
    "name": "BLVK",
    "slug": "blvk",
    "firstLetter": "B"
  },
  {
    "name": "BMW",
    "slug": "bmw",
    "firstLetter": "B"
  },
  {
    "name": "Boadicea",
    "slug": "boadicea",
    "firstLetter": "B"
  },
  {
    "name": "Bodytech",
    "slug": "bodytech",
    "firstLetter": "B"
  },
  {
    "name": "Boé",
    "slug": "boe",
    "firstLetter": "B"
  },
  {
    "name": "Bollini",
    "slug": "bollini",
    "firstLetter": "B"
  },
  {
    "name": "Bols",
    "slug": "bols",
    "firstLetter": "B"
  },
  {
    "name": "Bombay",
    "slug": "bombay",
    "firstLetter": "B"
  },
  {
    "name": "Boombastic",
    "slug": "boombastic",
    "firstLetter": "B"
  },
  {
    "name": "Booster",
    "slug": "booster",
    "firstLetter": "B"
  },
  {
    "name": "Borges",
    "slug": "borges",
    "firstLetter": "B"
  },
  {
    "name": "Born in France",
    "slug": "born-in-france",
    "firstLetter": "B"
  },
  {
    "name": "Born to Vape",
    "slug": "born-to-vape",
    "firstLetter": "B"
  },
  {
    "name": "Borntostandout",
    "slug": "borntostandout",
    "firstLetter": "B"
  },
  {
    "name": "Bosch",
    "slug": "bosch",
    "firstLetter": "B"
  },
  {
    "name": "Bose",
    "slug": "bose",
    "firstLetter": "B"
  },
  {
    "name": "Boss",
    "slug": "boss",
    "firstLetter": "B"
  },
  {
    "name": "Bottega",
    "slug": "bottega",
    "firstLetter": "B"
  },
  {
    "name": "Boucheron",
    "slug": "boucheron",
    "firstLetter": "B"
  },
  {
    "name": "Boulevard",
    "slug": "boulevard",
    "firstLetter": "B"
  },
  {
    "name": "Boya",
    "slug": "boya",
    "firstLetter": "B"
  },
  {
    "name": "Braccialini",
    "slug": "braccialini",
    "firstLetter": "B"
  },
  {
    "name": "Bramare",
    "slug": "bramare",
    "firstLetter": "B"
  },
  {
    "name": "Brasilberg",
    "slug": "brasilberg",
    "firstLetter": "B"
  },
  {
    "name": "Braun",
    "slug": "braun",
    "firstLetter": "B"
  },
  {
    "name": "Breeze",
    "slug": "breeze",
    "firstLetter": "B"
  },
  {
    "name": "Britania",
    "slug": "britania",
    "firstLetter": "B"
  },
  {
    "name": "Britney Spears",
    "slug": "britney-spears",
    "firstLetter": "B"
  },
  {
    "name": "Brooks",
    "slug": "brooks",
    "firstLetter": "B"
  },
  {
    "name": "Brother",
    "slug": "brother",
    "firstLetter": "B"
  },
  {
    "name": "Bruichladdich",
    "slug": "bruichladdich",
    "firstLetter": "B"
  },
  {
    "name": "Brut",
    "slug": "brut",
    "firstLetter": "B"
  },
  {
    "name": "BSN",
    "slug": "bsn",
    "firstLetter": "B"
  },
  {
    "name": "BTV",
    "slug": "btv",
    "firstLetter": "B"
  },
  {
    "name": "Bubba",
    "slug": "bubba",
    "firstLetter": "B"
  },
  {
    "name": "Buchanan’s",
    "slug": "buchanans",
    "firstLetter": "B"
  },
  {
    "name": "Budweiser",
    "slug": "budweiser",
    "firstLetter": "B"
  },
  {
    "name": "Bugs Bar",
    "slug": "bugs-bar",
    "firstLetter": "B"
  },
  {
    "name": "Bulldog",
    "slug": "bulldog",
    "firstLetter": "B"
  },
  {
    "name": "Bulleit Bourbon",
    "slug": "bulleit-bourbon",
    "firstLetter": "B"
  },
  {
    "name": "Bullpadel",
    "slug": "bullpadel",
    "firstLetter": "B"
  },
  {
    "name": "Bulova",
    "slug": "bulova",
    "firstLetter": "B"
  },
  {
    "name": "Burberry",
    "slug": "burberry",
    "firstLetter": "B"
  },
  {
    "name": "Burnett's",
    "slug": "burnetts",
    "firstLetter": "B"
  },
  {
    "name": "Bushnell",
    "slug": "bushnell",
    "firstLetter": "B"
  },
  {
    "name": "Bvlgari",
    "slug": "bvlgari",
    "firstLetter": "B"
  },
  {
    "name": "Byrobot",
    "slug": "byrobot",
    "firstLetter": "B"
  },
  {
    "name": "C Idea",
    "slug": "c-idea",
    "firstLetter": "C"
  },
  {
    "name": "C4 Energy",
    "slug": "c4-energy",
    "firstLetter": "C"
  },
  {
    "name": "Cabrales",
    "slug": "cabrales",
    "firstLetter": "C"
  },
  {
    "name": "Cachamai",
    "slug": "cachamai",
    "firstLetter": "C"
  },
  {
    "name": "Cacharel",
    "slug": "cacharel",
    "firstLetter": "C"
  },
  {
    "name": "Cadbury",
    "slug": "cadbury",
    "firstLetter": "C"
  },
  {
    "name": "Cafe Café",
    "slug": "cafe-cafe",
    "firstLetter": "C"
  },
  {
    "name": "Caffo",
    "slug": "caffo",
    "firstLetter": "C"
  },
  {
    "name": "Caloi",
    "slug": "caloi",
    "firstLetter": "C"
  },
  {
    "name": "Calvet",
    "slug": "calvet",
    "firstLetter": "C"
  },
  {
    "name": "Calvin Klein",
    "slug": "calvin-klein",
    "firstLetter": "C"
  },
  {
    "name": "Camara",
    "slug": "camara",
    "firstLetter": "C"
  },
  {
    "name": "CamelBak",
    "slug": "camelbak",
    "firstLetter": "C"
  },
  {
    "name": "Cameo",
    "slug": "cameo",
    "firstLetter": "C"
  },
  {
    "name": "Campari",
    "slug": "campari",
    "firstLetter": "C"
  },
  {
    "name": "Cannagin",
    "slug": "cannagin",
    "firstLetter": "C"
  },
  {
    "name": "Cannamela",
    "slug": "cannamela",
    "firstLetter": "C"
  },
  {
    "name": "Capitan Cuac",
    "slug": "capitan-cuac",
    "firstLetter": "C"
  },
  {
    "name": "Captain Morgan",
    "slug": "captain-morgan",
    "firstLetter": "C"
  },
  {
    "name": "Carbonell",
    "slug": "carbonell",
    "firstLetter": "C"
  },
  {
    "name": "Carey",
    "slug": "carey",
    "firstLetter": "C"
  },
  {
    "name": "Carioca",
    "slug": "carioca",
    "firstLetter": "C"
  },
  {
    "name": "Carlevana",
    "slug": "carlevana",
    "firstLetter": "C"
  },
  {
    "name": "Carmen",
    "slug": "carmen",
    "firstLetter": "C"
  },
  {
    "name": "Carmencita",
    "slug": "carmencita",
    "firstLetter": "C"
  },
  {
    "name": "Carolina Herrera",
    "slug": "carolina-herrera",
    "firstLetter": "C"
  },
  {
    "name": "Carrera",
    "slug": "carrera",
    "firstLetter": "C"
  },
  {
    "name": "Carrier",
    "slug": "carrier",
    "firstLetter": "C"
  },
  {
    "name": "Cartier",
    "slug": "cartier",
    "firstLetter": "C"
  },
  {
    "name": "Carven",
    "slug": "carven",
    "firstLetter": "C"
  },
  {
    "name": "Casa Donoso",
    "slug": "casa-donoso",
    "firstLetter": "C"
  },
  {
    "name": "Case Logic",
    "slug": "case-logic",
    "firstLetter": "C"
  },
  {
    "name": "Casillero Del Diablo",
    "slug": "casillero-del-diablo",
    "firstLetter": "C"
  },
  {
    "name": "Casio",
    "slug": "casio",
    "firstLetter": "C"
  },
  {
    "name": "Castel Mimi",
    "slug": "castel-mimi",
    "firstLetter": "C"
  },
  {
    "name": "Caterpillar",
    "slug": "caterpillar",
    "firstLetter": "C"
  },
  {
    "name": "Catto's",
    "slug": "cattos",
    "firstLetter": "C"
  },
  {
    "name": "Cavendish & Harvey",
    "slug": "cavendish-harvey",
    "firstLetter": "C"
  },
  {
    "name": "CCE",
    "slug": "cce",
    "firstLetter": "C"
  },
  {
    "name": "Cecchi",
    "slug": "cecchi",
    "firstLetter": "C"
  },
  {
    "name": "Celestron",
    "slug": "celestron",
    "firstLetter": "C"
  },
  {
    "name": "Celimax",
    "slug": "celimax",
    "firstLetter": "C"
  },
  {
    "name": "Cellini",
    "slug": "cellini",
    "firstLetter": "C"
  },
  {
    "name": "Century",
    "slug": "century",
    "firstLetter": "C"
  },
  {
    "name": "Cetaphil",
    "slug": "cetaphil",
    "firstLetter": "C"
  },
  {
    "name": "Champions",
    "slug": "champions",
    "firstLetter": "C"
  },
  {
    "name": "Chandon",
    "slug": "chandon",
    "firstLetter": "C"
  },
  {
    "name": "Chanel",
    "slug": "chanel",
    "firstLetter": "C"
  },
  {
    "name": "Chenson",
    "slug": "chenson",
    "firstLetter": "C"
  },
  {
    "name": "Chicco",
    "slug": "chicco",
    "firstLetter": "C"
  },
  {
    "name": "Chilly Beats",
    "slug": "chilly-beats",
    "firstLetter": "C"
  },
  {
    "name": "Chivas Regal",
    "slug": "chivas-regal",
    "firstLetter": "C"
  },
  {
    "name": "Chloé",
    "slug": "chloe",
    "firstLetter": "C"
  },
  {
    "name": "Choice Selection",
    "slug": "choice-selection",
    "firstLetter": "C"
  },
  {
    "name": "Cholula",
    "slug": "cholula",
    "firstLetter": "C"
  },
  {
    "name": "Chopard",
    "slug": "chopard",
    "firstLetter": "C"
  },
  {
    "name": "Chris Adams",
    "slug": "chris-adams",
    "firstLetter": "C"
  },
  {
    "name": "Christian Dior",
    "slug": "christian-dior",
    "firstLetter": "C"
  },
  {
    "name": "Christian Siriano",
    "slug": "christian-siriano",
    "firstLetter": "C"
  },
  {
    "name": "Christina Aguilera",
    "slug": "christina-aguilera",
    "firstLetter": "C"
  },
  {
    "name": "Christine Darvin",
    "slug": "christine-darvin",
    "firstLetter": "C"
  },
  {
    "name": "Chupa Chups",
    "slug": "chupa-chups",
    "firstLetter": "C"
  },
  {
    "name": "Ciga Design",
    "slug": "ciga-design",
    "firstLetter": "C"
  },
  {
    "name": "Cinebox",
    "slug": "cinebox",
    "firstLetter": "C"
  },
  {
    "name": "Ciroc",
    "slug": "ciroc",
    "firstLetter": "C"
  },
  {
    "name": "Cisco",
    "slug": "cisco",
    "firstLetter": "C"
  },
  {
    "name": "Citadelle",
    "slug": "citadelle",
    "firstLetter": "C"
  },
  {
    "name": "Citizen",
    "slug": "citizen",
    "firstLetter": "C"
  },
  {
    "name": "Clan MacGregor",
    "slug": "clan-macgregor",
    "firstLetter": "C"
  },
  {
    "name": "Clarion",
    "slug": "clarion",
    "firstLetter": "C"
  },
  {
    "name": "Climax",
    "slug": "climax",
    "firstLetter": "C"
  },
  {
    "name": "Clinians",
    "slug": "clinians",
    "firstLetter": "C"
  },
  {
    "name": "Clinique",
    "slug": "clinique",
    "firstLetter": "C"
  },
  {
    "name": "Coach",
    "slug": "coach",
    "firstLetter": "C"
  },
  {
    "name": "Cobos",
    "slug": "cobos",
    "firstLetter": "C"
  },
  {
    "name": "Cobra",
    "slug": "cobra",
    "firstLetter": "C"
  },
  {
    "name": "Coby",
    "slug": "coby",
    "firstLetter": "C"
  },
  {
    "name": "Coca-Cola",
    "slug": "coca-cola",
    "firstLetter": "C"
  },
  {
    "name": "Cocodinus",
    "slug": "cocodinus",
    "firstLetter": "C"
  },
  {
    "name": "Cofinluxe",
    "slug": "cofinluxe",
    "firstLetter": "C"
  },
  {
    "name": "Cogo",
    "slug": "cogo",
    "firstLetter": "C"
  },
  {
    "name": "Coilart",
    "slug": "coilart",
    "firstLetter": "C"
  },
  {
    "name": "Cointreau",
    "slug": "cointreau",
    "firstLetter": "C"
  },
  {
    "name": "Colavita",
    "slug": "colavita",
    "firstLetter": "C"
  },
  {
    "name": "Coleman",
    "slug": "coleman",
    "firstLetter": "C"
  },
  {
    "name": "Color Box",
    "slug": "color-box",
    "firstLetter": "C"
  },
  {
    "name": "Colorful",
    "slug": "colorful",
    "firstLetter": "C"
  },
  {
    "name": "Colour Me",
    "slug": "colour-me",
    "firstLetter": "C"
  },
  {
    "name": "Compaq",
    "slug": "compaq",
    "firstLetter": "C"
  },
  {
    "name": "Conair",
    "slug": "conair",
    "firstLetter": "C"
  },
  {
    "name": "Concha y Toro",
    "slug": "concha-y-toro",
    "firstLetter": "C"
  },
  {
    "name": "Conde de Serpa",
    "slug": "conde-de-serpa",
    "firstLetter": "C"
  },
  {
    "name": "Conforterm",
    "slug": "conforterm",
    "firstLetter": "C"
  },
  {
    "name": "Conlux",
    "slug": "conlux",
    "firstLetter": "C"
  },
  {
    "name": "Consumer",
    "slug": "consumer",
    "firstLetter": "C"
  },
  {
    "name": "Contigo",
    "slug": "contigo",
    "firstLetter": "C"
  },
  {
    "name": "Continental",
    "slug": "continental",
    "firstLetter": "C"
  },
  {
    "name": "Convento da Glória",
    "slug": "convento-da-gloria",
    "firstLetter": "C"
  },
  {
    "name": "Converse",
    "slug": "converse",
    "firstLetter": "C"
  },
  {
    "name": "Cool & Cool",
    "slug": "cool-cool",
    "firstLetter": "C"
  },
  {
    "name": "Cooler Master",
    "slug": "cooler-master",
    "firstLetter": "C"
  },
  {
    "name": "Coppenrath",
    "slug": "coppenrath",
    "firstLetter": "C"
  },
  {
    "name": "Corona",
    "slug": "corona",
    "firstLetter": "C"
  },
  {
    "name": "Corsair",
    "slug": "corsair",
    "firstLetter": "C"
  },
  {
    "name": "Costa",
    "slug": "costa",
    "firstLetter": "C"
  },
  {
    "name": "Costa d'Oro",
    "slug": "costa-doro",
    "firstLetter": "C"
  },
  {
    "name": "Cougar",
    "slug": "cougar",
    "firstLetter": "C"
  },
  {
    "name": "Cragganmore",
    "slug": "cragganmore",
    "firstLetter": "C"
  },
  {
    "name": "Crayola",
    "slug": "crayola",
    "firstLetter": "C"
  },
  {
    "name": "Crazon",
    "slug": "crazon",
    "firstLetter": "C"
  },
  {
    "name": "Creality",
    "slug": "creality",
    "firstLetter": "C"
  },
  {
    "name": "Creed",
    "slug": "creed",
    "firstLetter": "C"
  },
  {
    "name": "Cricova",
    "slug": "cricova",
    "firstLetter": "C"
  },
  {
    "name": "Crisco",
    "slug": "crisco",
    "firstLetter": "C"
  },
  {
    "name": "Cristiano Ronaldo",
    "slug": "cristiano-ronaldo",
    "firstLetter": "C"
  },
  {
    "name": "Crocs",
    "slug": "crocs",
    "firstLetter": "C"
  },
  {
    "name": "Crucial",
    "slug": "crucial",
    "firstLetter": "C"
  },
  {
    "name": "Crystal Head",
    "slug": "crystal-head",
    "firstLetter": "C"
  },
  {
    "name": "Cuba",
    "slug": "cuba",
    "firstLetter": "C"
  },
  {
    "name": "Cubot",
    "slug": "cubot",
    "firstLetter": "C"
  },
  {
    "name": "Cudy",
    "slug": "cudy",
    "firstLetter": "C"
  },
  {
    "name": "Cuisinart",
    "slug": "cuisinart",
    "firstLetter": "C"
  },
  {
    "name": "Cusenier",
    "slug": "cusenier",
    "firstLetter": "C"
  },
  {
    "name": "Cutty Sark",
    "slug": "cutty-sark",
    "firstLetter": "C"
  },
  {
    "name": "CVC",
    "slug": "cvc",
    "firstLetter": "C"
  },
  {
    "name": "Cyrus",
    "slug": "cyrus",
    "firstLetter": "C"
  },
  {
    "name": "D-Cell",
    "slug": "d-cell",
    "firstLetter": "D"
  },
  {
    "name": "D-Link",
    "slug": "d-link",
    "firstLetter": "D"
  },
  {
    "name": "D.V. Catena",
    "slug": "dv-catena",
    "firstLetter": "D"
  },
  {
    "name": "Daddario",
    "slug": "daddario",
    "firstLetter": "D"
  },
  {
    "name": "Daewoo",
    "slug": "daewoo",
    "firstLetter": "D"
  },
  {
    "name": "Dahua",
    "slug": "dahua",
    "firstLetter": "D"
  },
  {
    "name": "Daiwa",
    "slug": "daiwa",
    "firstLetter": "D"
  },
  {
    "name": "Dallmayr",
    "slug": "dallmayr",
    "firstLetter": "D"
  },
  {
    "name": "Dammann Frères",
    "slug": "dammann-freres",
    "firstLetter": "D"
  },
  {
    "name": "Daniel Klein",
    "slug": "daniel-klein",
    "firstLetter": "D"
  },
  {
    "name": "Daniel Wellington",
    "slug": "daniel-wellington",
    "firstLetter": "D"
  },
  {
    "name": "Danisa",
    "slug": "danisa",
    "firstLetter": "D"
  },
  {
    "name": "Dante",
    "slug": "dante",
    "firstLetter": "D"
  },
  {
    "name": "Danzka",
    "slug": "danzka",
    "firstLetter": "D"
  },
  {
    "name": "Dar El Ward",
    "slug": "dar-el-ward",
    "firstLetter": "D"
  },
  {
    "name": "Dark Dog",
    "slug": "dark-dog",
    "firstLetter": "D"
  },
  {
    "name": "DarkFlash",
    "slug": "darkflash",
    "firstLetter": "D"
  },
  {
    "name": "David Beckham",
    "slug": "david-beckham",
    "firstLetter": "D"
  },
  {
    "name": "David Jones",
    "slug": "david-jones",
    "firstLetter": "D"
  },
  {
    "name": "Davidoff",
    "slug": "davidoff",
    "firstLetter": "D"
  },
  {
    "name": "DC Shoes",
    "slug": "dc-shoes",
    "firstLetter": "D"
  },
  {
    "name": "Ddpai",
    "slug": "ddpai",
    "firstLetter": "D"
  },
  {
    "name": "De Cecco",
    "slug": "de-cecco",
    "firstLetter": "D"
  },
  {
    "name": "De Kuyper",
    "slug": "de-kuyper",
    "firstLetter": "D"
  },
  {
    "name": "Definitive Tech",
    "slug": "definitive-tech",
    "firstLetter": "D"
  },
  {
    "name": "Delgacil",
    "slug": "delgacil",
    "firstLetter": "D"
  },
  {
    "name": "Delice Solaire",
    "slug": "delice-solaire",
    "firstLetter": "D"
  },
  {
    "name": "Dell",
    "slug": "dell",
    "firstLetter": "D"
  },
  {
    "name": "Denon",
    "slug": "denon",
    "firstLetter": "D"
  },
  {
    "name": "Devsana",
    "slug": "devsana",
    "firstLetter": "D"
  },
  {
    "name": "Diesel",
    "slug": "diesel",
    "firstLetter": "D"
  },
  {
    "name": "Dignite",
    "slug": "dignite",
    "firstLetter": "D"
  },
  {
    "name": "Dinner Lady",
    "slug": "dinner-lady",
    "firstLetter": "D"
  },
  {
    "name": "Disney",
    "slug": "disney",
    "firstLetter": "D"
  },
  {
    "name": "DJI",
    "slug": "dji",
    "firstLetter": "D"
  },
  {
    "name": "Dlux",
    "slug": "dlux",
    "firstLetter": "D"
  },
  {
    "name": "Docile",
    "slug": "docile",
    "firstLetter": "D"
  },
  {
    "name": "Dolce & Gabbana",
    "slug": "dolce-gabbana",
    "firstLetter": "D"
  },
  {
    "name": "Dom Perignon",
    "slug": "dom-perignon",
    "firstLetter": "D"
  },
  {
    "name": "Don Julio",
    "slug": "don-julio",
    "firstLetter": "D"
  },
  {
    "name": "Doña Paula",
    "slug": "dona-paula",
    "firstLetter": "D"
  },
  {
    "name": "Donna Karan",
    "slug": "donna-karan",
    "firstLetter": "D"
  },
  {
    "name": "Doogee",
    "slug": "doogee",
    "firstLetter": "D"
  },
  {
    "name": "Dorall Collection",
    "slug": "dorall-collection",
    "firstLetter": "D"
  },
  {
    "name": "Dori",
    "slug": "dori",
    "firstLetter": "D"
  },
  {
    "name": "Dotcom",
    "slug": "dotcom",
    "firstLetter": "D"
  },
  {
    "name": "Dotmod",
    "slug": "dotmod",
    "firstLetter": "D"
  },
  {
    "name": "Dove",
    "slug": "dove",
    "firstLetter": "D"
  },
  {
    "name": "Dr House",
    "slug": "dr-house",
    "firstLetter": "D"
  },
  {
    "name": "Dragon",
    "slug": "dragon",
    "firstLetter": "D"
  },
  {
    "name": "Dragon Pharma",
    "slug": "dragon-pharma",
    "firstLetter": "D"
  },
  {
    "name": "Drambuie",
    "slug": "drambuie",
    "firstLetter": "D"
  },
  {
    "name": "Dreame",
    "slug": "dreame",
    "firstLetter": "D"
  },
  {
    "name": "DreamGEAR",
    "slug": "dreamgear",
    "firstLetter": "D"
  },
  {
    "name": "Dronic",
    "slug": "dronic",
    "firstLetter": "D"
  },
  {
    "name": "Drop Shot",
    "slug": "drop-shot",
    "firstLetter": "D"
  },
  {
    "name": "DSP",
    "slug": "dsp",
    "firstLetter": "D"
  },
  {
    "name": "Dsquared2",
    "slug": "dsquared2",
    "firstLetter": "D"
  },
  {
    "name": "Dub",
    "slug": "dub",
    "firstLetter": "D"
  },
  {
    "name": "Duel",
    "slug": "duel",
    "firstLetter": "D"
  },
  {
    "name": "Dulce Manjar",
    "slug": "dulce-manjar",
    "firstLetter": "D"
  },
  {
    "name": "Dumont",
    "slug": "dumont",
    "firstLetter": "D"
  },
  {
    "name": "Dunhill",
    "slug": "dunhill",
    "firstLetter": "D"
  },
  {
    "name": "Dunlop",
    "slug": "dunlop",
    "firstLetter": "D"
  },
  {
    "name": "Duosat",
    "slug": "duosat",
    "firstLetter": "D"
  },
  {
    "name": "Duracell",
    "slug": "duracell",
    "firstLetter": "D"
  },
  {
    "name": "Dymatize",
    "slug": "dymatize",
    "firstLetter": "D"
  },
  {
    "name": "Dynabook",
    "slug": "dynabook",
    "firstLetter": "D"
  },
  {
    "name": "Dyson",
    "slug": "dyson",
    "firstLetter": "D"
  },
  {
    "name": "E-Reise",
    "slug": "e-reise",
    "firstLetter": "E"
  },
  {
    "name": "E-Tech",
    "slug": "e-tech",
    "firstLetter": "E"
  },
  {
    "name": "Eai TV",
    "slug": "eai-tv",
    "firstLetter": "E"
  },
  {
    "name": "Earth's Creation",
    "slug": "earths-creation",
    "firstLetter": "E"
  },
  {
    "name": "Ebuzz",
    "slug": "ebuzz",
    "firstLetter": "E"
  },
  {
    "name": "Ecko",
    "slug": "ecko",
    "firstLetter": "E"
  },
  {
    "name": "Eco Mania",
    "slug": "eco-mania",
    "firstLetter": "E"
  },
  {
    "name": "EcoFlow",
    "slug": "ecoflow",
    "firstLetter": "E"
  },
  {
    "name": "EcoGreen",
    "slug": "ecogreen",
    "firstLetter": "E"
  },
  {
    "name": "Ecopower",
    "slug": "ecopower",
    "firstLetter": "E"
  },
  {
    "name": "Ecoramic",
    "slug": "ecoramic",
    "firstLetter": "E"
  },
  {
    "name": "Ecovacs",
    "slug": "ecovacs",
    "firstLetter": "E"
  },
  {
    "name": "Ecoxtreme",
    "slug": "ecoxtreme",
    "firstLetter": "E"
  },
  {
    "name": "Edeka",
    "slug": "edeka",
    "firstLetter": "E"
  },
  {
    "name": "Edelmeister",
    "slug": "edelmeister",
    "firstLetter": "E"
  },
  {
    "name": "Edifier",
    "slug": "edifier",
    "firstLetter": "E"
  },
  {
    "name": "Efest",
    "slug": "efest",
    "firstLetter": "E"
  },
  {
    "name": "Egoista",
    "slug": "egoista",
    "firstLetter": "E"
  },
  {
    "name": "Eisenbahn",
    "slug": "eisenbahn",
    "firstLetter": "E"
  },
  {
    "name": "El Avion",
    "slug": "el-avion",
    "firstLetter": "E"
  },
  {
    "name": "El Enemigo",
    "slug": "el-enemigo",
    "firstLetter": "E"
  },
  {
    "name": "El Padrino",
    "slug": "el-padrino",
    "firstLetter": "E"
  },
  {
    "name": "El Principal",
    "slug": "el-principal",
    "firstLetter": "E"
  },
  {
    "name": "Elago",
    "slug": "elago",
    "firstLetter": "E"
  },
  {
    "name": "Eleaf",
    "slug": "eleaf",
    "firstLetter": "E"
  },
  {
    "name": "ElectroBras",
    "slug": "electrobras",
    "firstLetter": "E"
  },
  {
    "name": "ElectroPro",
    "slug": "electropro",
    "firstLetter": "E"
  },
  {
    "name": "Elegoo",
    "slug": "elegoo",
    "firstLetter": "E"
  },
  {
    "name": "Elemento Puro",
    "slug": "elemento-puro",
    "firstLetter": "E"
  },
  {
    "name": "Elfbar",
    "slug": "elfbar",
    "firstLetter": "E"
  },
  {
    "name": "Elfworld",
    "slug": "elfworld",
    "firstLetter": "E"
  },
  {
    "name": "Elg",
    "slug": "elg",
    "firstLetter": "E"
  },
  {
    "name": "Elgato",
    "slug": "elgato",
    "firstLetter": "E"
  },
  {
    "name": "Elgin",
    "slug": "elgin",
    "firstLetter": "E"
  },
  {
    "name": "Elie Saab",
    "slug": "elie-saab",
    "firstLetter": "E"
  },
  {
    "name": "Elizabeth Arden",
    "slug": "elizabeth-arden",
    "firstLetter": "E"
  },
  {
    "name": "Elizabeth Taylor",
    "slug": "elizabeth-taylor",
    "firstLetter": "E"
  },
  {
    "name": "Elodie Roy",
    "slug": "elodie-roy",
    "firstLetter": "E"
  },
  {
    "name": "Elysees Fashion",
    "slug": "elysees-fashion",
    "firstLetter": "E"
  },
  {
    "name": "Emanuel Ungaro",
    "slug": "emanuel-ungaro",
    "firstLetter": "E"
  },
  {
    "name": "Emiliana",
    "slug": "emiliana",
    "firstLetter": "E"
  },
  {
    "name": "Emper",
    "slug": "emper",
    "firstLetter": "E"
  },
  {
    "name": "Encore",
    "slug": "encore",
    "firstLetter": "E"
  },
  {
    "name": "EnGenius",
    "slug": "engenius",
    "firstLetter": "E"
  },
  {
    "name": "Enrico Coveri",
    "slug": "enrico-coveri",
    "firstLetter": "E"
  },
  {
    "name": "Enzo",
    "slug": "enzo",
    "firstLetter": "E"
  },
  {
    "name": "Epiphone",
    "slug": "epiphone",
    "firstLetter": "E"
  },
  {
    "name": "Epson",
    "slug": "epson",
    "firstLetter": "E"
  },
  {
    "name": "Equissolis",
    "slug": "equissolis",
    "firstLetter": "E"
  },
  {
    "name": "Erdinger",
    "slug": "erdinger",
    "firstLetter": "E"
  },
  {
    "name": "Errazuriz",
    "slug": "errazuriz",
    "firstLetter": "E"
  },
  {
    "name": "Escada",
    "slug": "escada",
    "firstLetter": "E"
  },
  {
    "name": "Espirit de Versailles",
    "slug": "espirit-de-versailles",
    "firstLetter": "E"
  },
  {
    "name": "Espiritu de Chile",
    "slug": "espiritu-de-chile",
    "firstLetter": "E"
  },
  {
    "name": "Esse Strikes The Notes",
    "slug": "esse-strikes-the-notes",
    "firstLetter": "E"
  },
  {
    "name": "Essenza",
    "slug": "essenza",
    "firstLetter": "E"
  },
  {
    "name": "Estée Lauder",
    "slug": "estee-lauder",
    "firstLetter": "E"
  },
  {
    "name": "Estelle Ewen",
    "slug": "estelle-ewen",
    "firstLetter": "E"
  },
  {
    "name": "Estrella Galicia",
    "slug": "estrella-galicia",
    "firstLetter": "E"
  },
  {
    "name": "ETV Box",
    "slug": "etv-box",
    "firstLetter": "E"
  },
  {
    "name": "Eucerin",
    "slug": "eucerin",
    "firstLetter": "E"
  },
  {
    "name": "Evaflor",
    "slug": "evaflor",
    "firstLetter": "E"
  },
  {
    "name": "Evan Williams",
    "slug": "evan-williams",
    "firstLetter": "E"
  },
  {
    "name": "Everlast",
    "slug": "everlast",
    "firstLetter": "E"
  },
  {
    "name": "EVGA",
    "slug": "evga",
    "firstLetter": "E"
  },
  {
    "name": "Evoluderm",
    "slug": "evoluderm",
    "firstLetter": "E"
  },
  {
    "name": "Evoo",
    "slug": "evoo",
    "firstLetter": "E"
  },
  {
    "name": "Ewtto",
    "slug": "ewtto",
    "firstLetter": "E"
  },
  {
    "name": "Excellent",
    "slug": "excellent",
    "firstLetter": "E"
  },
  {
    "name": "Extreme",
    "slug": "extreme",
    "firstLetter": "E"
  },
  {
    "name": "Ezflow",
    "slug": "ezflow",
    "firstLetter": "E"
  },
  {
    "name": "Ezviz",
    "slug": "ezviz",
    "firstLetter": "E"
  },
  {
    "name": "FA",
    "slug": "fa",
    "firstLetter": "F"
  },
  {
    "name": "Faber Castell",
    "slug": "faber-castell",
    "firstLetter": "F"
  },
  {
    "name": "Façonnable",
    "slug": "faconnable",
    "firstLetter": "F"
  },
  {
    "name": "Falcon",
    "slug": "falcon",
    "firstLetter": "F"
  },
  {
    "name": "Familia Blanco",
    "slug": "familia-blanco",
    "firstLetter": "F"
  },
  {
    "name": "Fanvil",
    "slug": "fanvil",
    "firstLetter": "F"
  },
  {
    "name": "Fariis",
    "slug": "fariis",
    "firstLetter": "F"
  },
  {
    "name": "Fat Panda",
    "slug": "fat-panda",
    "firstLetter": "F"
  },
  {
    "name": "Feelworld",
    "slug": "feelworld",
    "firstLetter": "F"
  },
  {
    "name": "Fender",
    "slug": "fender",
    "firstLetter": "F"
  },
  {
    "name": "Fenix",
    "slug": "fenix",
    "firstLetter": "F"
  },
  {
    "name": "Ferox",
    "slug": "ferox",
    "firstLetter": "F"
  },
  {
    "name": "Ferrari",
    "slug": "ferrari",
    "firstLetter": "F"
  },
  {
    "name": "Ferrero",
    "slug": "ferrero",
    "firstLetter": "F"
  },
  {
    "name": "Festina",
    "slug": "festina",
    "firstLetter": "F"
  },
  {
    "name": "FGT",
    "slug": "fgt",
    "firstLetter": "F"
  },
  {
    "name": "Fiat 500",
    "slug": "fiat-500",
    "firstLetter": "F"
  },
  {
    "name": "FiberHome",
    "slug": "fiberhome",
    "firstLetter": "F"
  },
  {
    "name": "Fifine",
    "slug": "fifine",
    "firstLetter": "F"
  },
  {
    "name": "Fifty Pounds",
    "slug": "fifty-pounds",
    "firstLetter": "F"
  },
  {
    "name": "Fila",
    "slug": "fila",
    "firstLetter": "F"
  },
  {
    "name": "Filippo Berio",
    "slug": "filippo-berio",
    "firstLetter": "F"
  },
  {
    "name": "Finca El Origen",
    "slug": "finca-el-origen",
    "firstLetter": "F"
  },
  {
    "name": "Fini",
    "slug": "fini",
    "firstLetter": "F"
  },
  {
    "name": "Fisher Price",
    "slug": "fisher-price",
    "firstLetter": "F"
  },
  {
    "name": "Fitbit",
    "slug": "fitbit",
    "firstLetter": "F"
  },
  {
    "name": "Fixman",
    "slug": "fixman",
    "firstLetter": "F"
  },
  {
    "name": "Flashforge",
    "slug": "flashforge",
    "firstLetter": "F"
  },
  {
    "name": "Flavia",
    "slug": "flavia",
    "firstLetter": "F"
  },
  {
    "name": "Flensburger",
    "slug": "flensburger",
    "firstLetter": "F"
  },
  {
    "name": "Flor de Caña",
    "slug": "flor-de-cana",
    "firstLetter": "F"
  },
  {
    "name": "Flying Goose",
    "slug": "flying-goose",
    "firstLetter": "F"
  },
  {
    "name": "Flytec",
    "slug": "flytec",
    "firstLetter": "F"
  },
  {
    "name": "Focal",
    "slug": "focal",
    "firstLetter": "F"
  },
  {
    "name": "Fontaine",
    "slug": "fontaine",
    "firstLetter": "F"
  },
  {
    "name": "Food Club",
    "slug": "food-club",
    "firstLetter": "F"
  },
  {
    "name": "Forza",
    "slug": "forza",
    "firstLetter": "F"
  },
  {
    "name": "Fossibot",
    "slug": "fossibot",
    "firstLetter": "F"
  },
  {
    "name": "Fossil",
    "slug": "fossil",
    "firstLetter": "F"
  },
  {
    "name": "Foston",
    "slug": "foston",
    "firstLetter": "F"
  },
  {
    "name": "FQ777",
    "slug": "fq777",
    "firstLetter": "F"
  },
  {
    "name": "Fragluxe",
    "slug": "fragluxe",
    "firstLetter": "F"
  },
  {
    "name": "Fragonard",
    "slug": "fragonard",
    "firstLetter": "F"
  },
  {
    "name": "Frahm",
    "slug": "frahm",
    "firstLetter": "F"
  },
  {
    "name": "Franck Olivier",
    "slug": "franck-olivier",
    "firstLetter": "F"
  },
  {
    "name": "Frangelico",
    "slug": "frangelico",
    "firstLetter": "F"
  },
  {
    "name": "Frank's",
    "slug": "franks",
    "firstLetter": "F"
  },
  {
    "name": "Franziskaner",
    "slug": "franziskaner",
    "firstLetter": "F"
  },
  {
    "name": "Fred Hayman's",
    "slug": "fred-haymans",
    "firstLetter": "F"
  },
  {
    "name": "Free Home",
    "slug": "free-home",
    "firstLetter": "F"
  },
  {
    "name": "Freei",
    "slug": "freei",
    "firstLetter": "F"
  },
  {
    "name": "Freeman",
    "slug": "freeman",
    "firstLetter": "F"
  },
  {
    "name": "Freemax",
    "slug": "freemax",
    "firstLetter": "F"
  },
  {
    "name": "Freesky",
    "slug": "freesky",
    "firstLetter": "F"
  },
  {
    "name": "Freixenet",
    "slug": "freixenet",
    "firstLetter": "F"
  },
  {
    "name": "French Avenue",
    "slug": "french-avenue",
    "firstLetter": "F"
  },
  {
    "name": "French's",
    "slug": "frenchs",
    "firstLetter": "F"
  },
  {
    "name": "Friday",
    "slug": "friday",
    "firstLetter": "F"
  },
  {
    "name": "Frosty",
    "slug": "frosty",
    "firstLetter": "F"
  },
  {
    "name": "FTX",
    "slug": "ftx",
    "firstLetter": "F"
  },
  {
    "name": "Fujifilm",
    "slug": "fujifilm",
    "firstLetter": "F"
  },
  {
    "name": "Fume",
    "slug": "fume",
    "firstLetter": "F"
  },
  {
    "name": "Funko",
    "slug": "funko",
    "firstLetter": "F"
  },
  {
    "name": "Furla",
    "slug": "furla",
    "firstLetter": "F"
  },
  {
    "name": "Furuno",
    "slug": "furuno",
    "firstLetter": "F"
  },
  {
    "name": "G-Tide",
    "slug": "g-tide",
    "firstLetter": "G"
  },
  {
    "name": "G.Skill",
    "slug": "gskill",
    "firstLetter": "G"
  },
  {
    "name": "GA.MA",
    "slug": "gama",
    "firstLetter": "G"
  },
  {
    "name": "Gabriela Sabatini",
    "slug": "gabriela-sabatini",
    "firstLetter": "G"
  },
  {
    "name": "Gairriy",
    "slug": "gairriy",
    "firstLetter": "G"
  },
  {
    "name": "Galanz",
    "slug": "galanz",
    "firstLetter": "G"
  },
  {
    "name": "Galax",
    "slug": "galax",
    "firstLetter": "G"
  },
  {
    "name": "Galaxy Concept",
    "slug": "galaxy-concept",
    "firstLetter": "G"
  },
  {
    "name": "Galaxy Plus",
    "slug": "galaxy-plus",
    "firstLetter": "G"
  },
  {
    "name": "Gama Power",
    "slug": "gama-power",
    "firstLetter": "G"
  },
  {
    "name": "Gamdias",
    "slug": "gamdias",
    "firstLetter": "G"
  },
  {
    "name": "Game Box",
    "slug": "game-box",
    "firstLetter": "G"
  },
  {
    "name": "Gamemax",
    "slug": "gamemax",
    "firstLetter": "G"
  },
  {
    "name": "GameSir",
    "slug": "gamesir",
    "firstLetter": "G"
  },
  {
    "name": "Garmin",
    "slug": "garmin",
    "firstLetter": "G"
  },
  {
    "name": "Garnier",
    "slug": "garnier",
    "firstLetter": "G"
  },
  {
    "name": "Gateway",
    "slug": "gateway",
    "firstLetter": "G"
  },
  {
    "name": "Gati",
    "slug": "gati",
    "firstLetter": "G"
  },
  {
    "name": "GE",
    "slug": "ge",
    "firstLetter": "G"
  },
  {
    "name": "Geek Bar",
    "slug": "geek-bar",
    "firstLetter": "G"
  },
  {
    "name": "Geekvape",
    "slug": "geekvape",
    "firstLetter": "G"
  },
  {
    "name": "Gemini",
    "slug": "gemini",
    "firstLetter": "G"
  },
  {
    "name": "Geminis",
    "slug": "geminis",
    "firstLetter": "G"
  },
  {
    "name": "Gemma Di Luna",
    "slug": "gemma-di-luna",
    "firstLetter": "G"
  },
  {
    "name": "General Tire",
    "slug": "general-tire",
    "firstLetter": "G"
  },
  {
    "name": "Genesis",
    "slug": "genesis",
    "firstLetter": "G"
  },
  {
    "name": "Genius",
    "slug": "genius",
    "firstLetter": "G"
  },
  {
    "name": "Georges Mezotti",
    "slug": "georges-mezotti",
    "firstLetter": "G"
  },
  {
    "name": "Germaine de Capuccini",
    "slug": "germaine-de-capuccini",
    "firstLetter": "G"
  },
  {
    "name": "Geske",
    "slug": "geske",
    "firstLetter": "G"
  },
  {
    "name": "Ghis",
    "slug": "ghis",
    "firstLetter": "G"
  },
  {
    "name": "Gian Marco Venturi",
    "slug": "gian-marco-venturi",
    "firstLetter": "G"
  },
  {
    "name": "Gianfranco Ferre",
    "slug": "gianfranco-ferre",
    "firstLetter": "G"
  },
  {
    "name": "Gibson's",
    "slug": "gibsons",
    "firstLetter": "G"
  },
  {
    "name": "Gigabox",
    "slug": "gigabox",
    "firstLetter": "G"
  },
  {
    "name": "Gigabyte",
    "slug": "gigabyte",
    "firstLetter": "G"
  },
  {
    "name": "Gilbey's",
    "slug": "gilbeys",
    "firstLetter": "G"
  },
  {
    "name": "Gilles Cantuel",
    "slug": "gilles-cantuel",
    "firstLetter": "G"
  },
  {
    "name": "Gillette",
    "slug": "gillette",
    "firstLetter": "G"
  },
  {
    "name": "Giorgio Armani",
    "slug": "giorgio-armani",
    "firstLetter": "G"
  },
  {
    "name": "Giorgio Beverly Hills",
    "slug": "giorgio-beverly-hills",
    "firstLetter": "G"
  },
  {
    "name": "Gisada",
    "slug": "gisada",
    "firstLetter": "G"
  },
  {
    "name": "Givenchy",
    "slug": "givenchy",
    "firstLetter": "G"
  },
  {
    "name": "Glen Moray",
    "slug": "glen-moray",
    "firstLetter": "G"
  },
  {
    "name": "Glenfiddich",
    "slug": "glenfiddich",
    "firstLetter": "G"
  },
  {
    "name": "Glenkinchie",
    "slug": "glenkinchie",
    "firstLetter": "G"
  },
  {
    "name": "Glenmorangie",
    "slug": "glenmorangie",
    "firstLetter": "G"
  },
  {
    "name": "Globalsat",
    "slug": "globalsat",
    "firstLetter": "G"
  },
  {
    "name": "Glorious",
    "slug": "glorious",
    "firstLetter": "G"
  },
  {
    "name": "Gluconex",
    "slug": "gluconex",
    "firstLetter": "G"
  },
  {
    "name": "GMKtec",
    "slug": "gmktec",
    "firstLetter": "G"
  },
  {
    "name": "GNC",
    "slug": "gnc",
    "firstLetter": "G"
  },
  {
    "name": "Go Link",
    "slug": "go-link",
    "firstLetter": "G"
  },
  {
    "name": "Go Net",
    "slug": "go-net",
    "firstLetter": "G"
  },
  {
    "name": "Goal Pro",
    "slug": "goal-pro",
    "firstLetter": "G"
  },
  {
    "name": "Gobox",
    "slug": "gobox",
    "firstLetter": "G"
  },
  {
    "name": "Godiva",
    "slug": "godiva",
    "firstLetter": "G"
  },
  {
    "name": "Godox",
    "slug": "godox",
    "firstLetter": "G"
  },
  {
    "name": "Gold Bar",
    "slug": "gold-bar",
    "firstLetter": "G"
  },
  {
    "name": "Gold Edition",
    "slug": "gold-edition",
    "firstLetter": "G"
  },
  {
    "name": "Gold TV",
    "slug": "gold-tv",
    "firstLetter": "G"
  },
  {
    "name": "Goldkenn",
    "slug": "goldkenn",
    "firstLetter": "G"
  },
  {
    "name": "GoLine",
    "slug": "goline",
    "firstLetter": "G"
  },
  {
    "name": "Good Energy",
    "slug": "good-energy",
    "firstLetter": "G"
  },
  {
    "name": "Goodweather",
    "slug": "goodweather",
    "firstLetter": "G"
  },
  {
    "name": "Google",
    "slug": "google",
    "firstLetter": "G"
  },
  {
    "name": "Gopole",
    "slug": "gopole",
    "firstLetter": "G"
  },
  {
    "name": "GoPro",
    "slug": "gopro",
    "firstLetter": "G"
  },
  {
    "name": "Gorbatschow",
    "slug": "gorbatschow",
    "firstLetter": "G"
  },
  {
    "name": "Gordon's",
    "slug": "gordons",
    "firstLetter": "G"
  },
  {
    "name": "Gosat",
    "slug": "gosat",
    "firstLetter": "G"
  },
  {
    "name": "Gozio",
    "slug": "gozio",
    "firstLetter": "G"
  },
  {
    "name": "GP",
    "slug": "gp",
    "firstLetter": "G"
  },
  {
    "name": "Grace Of London",
    "slug": "grace-of-london",
    "firstLetter": "G"
  },
  {
    "name": "Gran Enemigo",
    "slug": "gran-enemigo",
    "firstLetter": "G"
  },
  {
    "name": "Grand Marula",
    "slug": "grand-marula",
    "firstLetter": "G"
  },
  {
    "name": "Grandeur",
    "slug": "grandeur",
    "firstLetter": "G"
  },
  {
    "name": "Grandstream",
    "slug": "grandstream",
    "firstLetter": "G"
  },
  {
    "name": "Grant's",
    "slug": "grants",
    "firstLetter": "G"
  },
  {
    "name": "Grasovka",
    "slug": "grasovka",
    "firstLetter": "G"
  },
  {
    "name": "Gree",
    "slug": "gree",
    "firstLetter": "G"
  },
  {
    "name": "Greenall's",
    "slug": "greenalls",
    "firstLetter": "G"
  },
  {
    "name": "Grés",
    "slug": "gres",
    "firstLetter": "G"
  },
  {
    "name": "Gretsch",
    "slug": "gretsch",
    "firstLetter": "G"
  },
  {
    "name": "Grey Goose",
    "slug": "grey-goose",
    "firstLetter": "G"
  },
  {
    "name": "Griffin",
    "slug": "griffin",
    "firstLetter": "G"
  },
  {
    "name": "Gritti",
    "slug": "gritti",
    "firstLetter": "G"
  },
  {
    "name": "Gucci",
    "slug": "gucci",
    "firstLetter": "G"
  },
  {
    "name": "Guerlain",
    "slug": "guerlain",
    "firstLetter": "G"
  },
  {
    "name": "Guess",
    "slug": "guess",
    "firstLetter": "G"
  },
  {
    "name": "Gulf Orchid",
    "slug": "gulf-orchid",
    "firstLetter": "G"
  },
  {
    "name": "Gullón",
    "slug": "gullon",
    "firstLetter": "G"
  },
  {
    "name": "Gunnar",
    "slug": "gunnar",
    "firstLetter": "G"
  },
  {
    "name": "Guy Laroche",
    "slug": "guy-laroche",
    "firstLetter": "G"
  },
  {
    "name": "Guylian",
    "slug": "guylian",
    "firstLetter": "G"
  },
  {
    "name": "Haagen-Dazs",
    "slug": "haagen-dazs",
    "firstLetter": "H"
  },
  {
    "name": "Haier",
    "slug": "haier",
    "firstLetter": "H"
  },
  {
    "name": "Hamidi",
    "slug": "hamidi",
    "firstLetter": "H"
  },
  {
    "name": "Hamilton Beach",
    "slug": "hamilton-beach",
    "firstLetter": "H"
  },
  {
    "name": "Hanin",
    "slug": "hanin",
    "firstLetter": "H"
  },
  {
    "name": "Haribo",
    "slug": "haribo",
    "firstLetter": "H"
  },
  {
    "name": "Harman/Kardon",
    "slug": "harmankardon",
    "firstLetter": "H"
  },
  {
    "name": "Hartke",
    "slug": "hartke",
    "firstLetter": "H"
  },
  {
    "name": "Hasa",
    "slug": "hasa",
    "firstLetter": "H"
  },
  {
    "name": "Hasbro",
    "slug": "hasbro",
    "firstLetter": "H"
  },
  {
    "name": "Haus Roland",
    "slug": "haus-roland",
    "firstLetter": "H"
  },
  {
    "name": "Havana Club",
    "slug": "havana-club",
    "firstLetter": "H"
  },
  {
    "name": "Havanna",
    "slug": "havanna",
    "firstLetter": "H"
  },
  {
    "name": "Havit",
    "slug": "havit",
    "firstLetter": "H"
  },
  {
    "name": "Hawaiian Tropic",
    "slug": "hawaiian-tropic",
    "firstLetter": "H"
  },
  {
    "name": "Hayman's",
    "slug": "haymans",
    "firstLetter": "H"
  },
  {
    "name": "HC Premium",
    "slug": "hc-premium",
    "firstLetter": "H"
  },
  {
    "name": "HD Play",
    "slug": "hd-play",
    "firstLetter": "H"
  },
  {
    "name": "Head",
    "slug": "head",
    "firstLetter": "H"
  },
  {
    "name": "Heiko",
    "slug": "heiko",
    "firstLetter": "H"
  },
  {
    "name": "Heineken",
    "slug": "heineken",
    "firstLetter": "H"
  },
  {
    "name": "Heinz",
    "slug": "heinz",
    "firstLetter": "H"
  },
  {
    "name": "Hendrick's",
    "slug": "hendricks",
    "firstLetter": "H"
  },
  {
    "name": "Henkell",
    "slug": "henkell",
    "firstLetter": "H"
  },
  {
    "name": "Herdez",
    "slug": "herdez",
    "firstLetter": "H"
  },
  {
    "name": "Hermes",
    "slug": "hermes",
    "firstLetter": "H"
  },
  {
    "name": "Hero",
    "slug": "hero",
    "firstLetter": "H"
  },
  {
    "name": "Heroes",
    "slug": "heroes",
    "firstLetter": "H"
  },
  {
    "name": "Hetzer",
    "slug": "hetzer",
    "firstLetter": "H"
  },
  {
    "name": "HighTV",
    "slug": "hightv",
    "firstLetter": "H"
  },
  {
    "name": "Hiksemi",
    "slug": "hiksemi",
    "firstLetter": "H"
  },
  {
    "name": "Hikvision",
    "slug": "hikvision",
    "firstLetter": "H"
  },
  {
    "name": "HiLook",
    "slug": "hilook",
    "firstLetter": "H"
  },
  {
    "name": "Hinor",
    "slug": "hinor",
    "firstLetter": "H"
  },
  {
    "name": "Hiram Walker",
    "slug": "hiram-walker",
    "firstLetter": "H"
  },
  {
    "name": "Hisense",
    "slug": "hisense",
    "firstLetter": "H"
  },
  {
    "name": "Hitachi",
    "slug": "hitachi",
    "firstLetter": "H"
  },
  {
    "name": "HJC",
    "slug": "hjc",
    "firstLetter": "H"
  },
  {
    "name": "Hohem",
    "slug": "hohem",
    "firstLetter": "H"
  },
  {
    "name": "Hollister",
    "slug": "hollister",
    "firstLetter": "H"
  },
  {
    "name": "Hollyland",
    "slug": "hollyland",
    "firstLetter": "H"
  },
  {
    "name": "Honeywell",
    "slug": "honeywell",
    "firstLetter": "H"
  },
  {
    "name": "Honor",
    "slug": "honor",
    "firstLetter": "H"
  },
  {
    "name": "Hopestar",
    "slug": "hopestar",
    "firstLetter": "H"
  },
  {
    "name": "Hori",
    "slug": "hori",
    "firstLetter": "H"
  },
  {
    "name": "Horseball",
    "slug": "horseball",
    "firstLetter": "H"
  },
  {
    "name": "Hoss",
    "slug": "hoss",
    "firstLetter": "H"
  },
  {
    "name": "Hotwav",
    "slug": "hotwav",
    "firstLetter": "H"
  },
  {
    "name": "HP",
    "slug": "hp",
    "firstLetter": "H"
  },
  {
    "name": "HQD",
    "slug": "hqd",
    "firstLetter": "H"
  },
  {
    "name": "HTC",
    "slug": "htc",
    "firstLetter": "H"
  },
  {
    "name": "HTV",
    "slug": "htv",
    "firstLetter": "H"
  },
  {
    "name": "Huawei",
    "slug": "huawei",
    "firstLetter": "H"
  },
  {
    "name": "Hubble Connected",
    "slug": "hubble-connected",
    "firstLetter": "H"
  },
  {
    "name": "Hugo Boss",
    "slug": "hugo-boss",
    "firstLetter": "H"
  },
  {
    "name": "Huion",
    "slug": "huion",
    "firstLetter": "H"
  },
  {
    "name": "Hunting Lodge",
    "slug": "hunting-lodge",
    "firstLetter": "H"
  },
  {
    "name": "Hydrapeak",
    "slug": "hydrapeak",
    "firstLetter": "H"
  },
  {
    "name": "Hydrate",
    "slug": "hydrate",
    "firstLetter": "H"
  },
  {
    "name": "Hydro Flask",
    "slug": "hydro-flask",
    "firstLetter": "H"
  },
  {
    "name": "HYE",
    "slug": "hye",
    "firstLetter": "H"
  },
  {
    "name": "Hynix",
    "slug": "hynix",
    "firstLetter": "H"
  },
  {
    "name": "HyperLink",
    "slug": "hyperlink",
    "firstLetter": "H"
  },
  {
    "name": "Hypnos",
    "slug": "hypnos",
    "firstLetter": "H"
  },
  {
    "name": "Hyppe",
    "slug": "hyppe",
    "firstLetter": "H"
  },
  {
    "name": "Hyte",
    "slug": "hyte",
    "firstLetter": "H"
  },
  {
    "name": "Hyundai",
    "slug": "hyundai",
    "firstLetter": "H"
  },
  {
    "name": "Ibanez",
    "slug": "ibanez",
    "firstLetter": "I"
  },
  {
    "name": "iBest",
    "slug": "ibest",
    "firstLetter": "I"
  },
  {
    "name": "Ibraheem Al.Qurashi",
    "slug": "ibraheem-alqurashi",
    "firstLetter": "I"
  },
  {
    "name": "Ice Breakers",
    "slug": "ice-breakers",
    "firstLetter": "I"
  },
  {
    "name": "Iceberg",
    "slug": "iceberg",
    "firstLetter": "I"
  },
  {
    "name": "iCOM",
    "slug": "icom",
    "firstLetter": "I"
  },
  {
    "name": "iFoved",
    "slug": "ifoved",
    "firstLetter": "I"
  },
  {
    "name": "Igloo",
    "slug": "igloo",
    "firstLetter": "I"
  },
  {
    "name": "Ignite",
    "slug": "ignite",
    "firstLetter": "I"
  },
  {
    "name": "iLuv",
    "slug": "iluv",
    "firstLetter": "I"
  },
  {
    "name": "Imou",
    "slug": "imou",
    "firstLetter": "I"
  },
  {
    "name": "Imperium",
    "slug": "imperium",
    "firstLetter": "I"
  },
  {
    "name": "Incode",
    "slug": "incode",
    "firstLetter": "I"
  },
  {
    "name": "Indomita",
    "slug": "indomita",
    "firstLetter": "I"
  },
  {
    "name": "Infinity",
    "slug": "infinity",
    "firstLetter": "I"
  },
  {
    "name": "Infinity Bar",
    "slug": "infinity-bar",
    "firstLetter": "I"
  },
  {
    "name": "Infinix",
    "slug": "infinix",
    "firstLetter": "I"
  },
  {
    "name": "Infocus",
    "slug": "infocus",
    "firstLetter": "I"
  },
  {
    "name": "Infosec",
    "slug": "infosec",
    "firstLetter": "I"
  },
  {
    "name": "Ingco",
    "slug": "ingco",
    "firstLetter": "I"
  },
  {
    "name": "Initio",
    "slug": "initio",
    "firstLetter": "I"
  },
  {
    "name": "Inove",
    "slug": "inove",
    "firstLetter": "I"
  },
  {
    "name": "Inovia",
    "slug": "inovia",
    "firstLetter": "I"
  },
  {
    "name": "Insignia",
    "slug": "insignia",
    "firstLetter": "I"
  },
  {
    "name": "Insta360",
    "slug": "insta360",
    "firstLetter": "I"
  },
  {
    "name": "Instituto Español",
    "slug": "instituto-espanol",
    "firstLetter": "I"
  },
  {
    "name": "Instyle",
    "slug": "instyle",
    "firstLetter": "I"
  },
  {
    "name": "Intel",
    "slug": "intel",
    "firstLetter": "I"
  },
  {
    "name": "Intelbras",
    "slug": "intelbras",
    "firstLetter": "I"
  },
  {
    "name": "Interbras",
    "slug": "interbras",
    "firstLetter": "I"
  },
  {
    "name": "Intesa",
    "slug": "intesa",
    "firstLetter": "I"
  },
  {
    "name": "Invicta",
    "slug": "invicta",
    "firstLetter": "I"
  },
  {
    "name": "Iomega",
    "slug": "iomega",
    "firstLetter": "I"
  },
  {
    "name": "Ion",
    "slug": "ion",
    "firstLetter": "I"
  },
  {
    "name": "Ipbox",
    "slug": "ipbox",
    "firstLetter": "I"
  },
  {
    "name": "iPrimeTV",
    "slug": "iprimetv",
    "firstLetter": "I"
  },
  {
    "name": "Ipro",
    "slug": "ipro",
    "firstLetter": "I"
  },
  {
    "name": "iRobot",
    "slug": "irobot",
    "firstLetter": "I"
  },
  {
    "name": "iScents",
    "slug": "iscents",
    "firstLetter": "I"
  },
  {
    "name": "iSound",
    "slug": "isound",
    "firstLetter": "I"
  },
  {
    "name": "Issey Miyake",
    "slug": "issey-miyake",
    "firstLetter": "I"
  },
  {
    "name": "Isurevape",
    "slug": "isurevape",
    "firstLetter": "I"
  },
  {
    "name": "Itatiaia",
    "slug": "itatiaia",
    "firstLetter": "I"
  },
  {
    "name": "Itel",
    "slug": "itel",
    "firstLetter": "I"
  },
  {
    "name": "ITV",
    "slug": "itv",
    "firstLetter": "I"
  },
  {
    "name": "Iuron",
    "slug": "iuron",
    "firstLetter": "I"
  },
  {
    "name": "J & B",
    "slug": "j-b",
    "firstLetter": "J"
  },
  {
    "name": "Jabra",
    "slug": "jabra",
    "firstLetter": "J"
  },
  {
    "name": "Jack Daniel's",
    "slug": "jack-daniels",
    "firstLetter": "J"
  },
  {
    "name": "Jack Hope",
    "slug": "jack-hope",
    "firstLetter": "J"
  },
  {
    "name": "Jackson",
    "slug": "jackson",
    "firstLetter": "J"
  },
  {
    "name": "Jacomo",
    "slug": "jacomo",
    "firstLetter": "J"
  },
  {
    "name": "Jacques Bogart",
    "slug": "jacques-bogart",
    "firstLetter": "J"
  },
  {
    "name": "Jagermeister",
    "slug": "jagermeister",
    "firstLetter": "J"
  },
  {
    "name": "Jaguar",
    "slug": "jaguar",
    "firstLetter": "J"
  },
  {
    "name": "Jameson",
    "slug": "jameson",
    "firstLetter": "J"
  },
  {
    "name": "Jamo",
    "slug": "jamo",
    "firstLetter": "J"
  },
  {
    "name": "JBK",
    "slug": "jbk",
    "firstLetter": "J"
  },
  {
    "name": "Jean Paul Gaultier",
    "slug": "jean-paul-gaultier",
    "firstLetter": "J"
  },
  {
    "name": "Jean Rish",
    "slug": "jean-rish",
    "firstLetter": "J"
  },
  {
    "name": "Jeanne Arthes",
    "slug": "jeanne-arthes",
    "firstLetter": "J"
  },
  {
    "name": "Jeanne En Provence",
    "slug": "jeanne-en-provence",
    "firstLetter": "J"
  },
  {
    "name": "Jeep",
    "slug": "jeep",
    "firstLetter": "J"
  },
  {
    "name": "Jennifer Lopez",
    "slug": "jennifer-lopez",
    "firstLetter": "J"
  },
  {
    "name": "Jesus Del Pozo",
    "slug": "jesus-del-pozo",
    "firstLetter": "J"
  },
  {
    "name": "Jim Beam",
    "slug": "jim-beam",
    "firstLetter": "J"
  },
  {
    "name": "Jimmy Choo",
    "slug": "jimmy-choo",
    "firstLetter": "J"
  },
  {
    "name": "JIO",
    "slug": "jio",
    "firstLetter": "J"
  },
  {
    "name": "Jo Malone London",
    "slug": "jo-malone-london",
    "firstLetter": "J"
  },
  {
    "name": "Jo Milano",
    "slug": "jo-milano",
    "firstLetter": "J"
  },
  {
    "name": "Joaquín Cortés",
    "slug": "joaquin-cortes",
    "firstLetter": "J"
  },
  {
    "name": "John Frieda",
    "slug": "john-frieda",
    "firstLetter": "J"
  },
  {
    "name": "John Lee",
    "slug": "john-lee",
    "firstLetter": "J"
  },
  {
    "name": "John Varvatos",
    "slug": "john-varvatos",
    "firstLetter": "J"
  },
  {
    "name": "Johnnie Walker",
    "slug": "johnnie-walker",
    "firstLetter": "J"
  },
  {
    "name": "Joico",
    "slug": "joico",
    "firstLetter": "J"
  },
  {
    "name": "Jolca",
    "slug": "jolca",
    "firstLetter": "J"
  },
  {
    "name": "Joli Joli",
    "slug": "joli-joli",
    "firstLetter": "J"
  },
  {
    "name": "Jonsbo",
    "slug": "jonsbo",
    "firstLetter": "J"
  },
  {
    "name": "Joop!",
    "slug": "joop",
    "firstLetter": "J"
  },
  {
    "name": "Jose Cuervo",
    "slug": "jose-cuervo",
    "firstLetter": "J"
  },
  {
    "name": "JOY",
    "slug": "joy",
    "firstLetter": "J"
  },
  {
    "name": "Juan Valdez",
    "slug": "juan-valdez",
    "firstLetter": "J"
  },
  {
    "name": "Juicy Couture",
    "slug": "juicy-couture",
    "firstLetter": "J"
  },
  {
    "name": "Jupiter",
    "slug": "jupiter",
    "firstLetter": "J"
  },
  {
    "name": "Jura",
    "slug": "jura",
    "firstLetter": "J"
  },
  {
    "name": "Just Cavalli",
    "slug": "just-cavalli",
    "firstLetter": "J"
  },
  {
    "name": "Just Jack",
    "slug": "just-jack",
    "firstLetter": "J"
  },
  {
    "name": "Just Juice",
    "slug": "just-juice",
    "firstLetter": "J"
  },
  {
    "name": "Juucy",
    "slug": "juucy",
    "firstLetter": "J"
  },
  {
    "name": "JVC",
    "slug": "jvc",
    "firstLetter": "J"
  },
  {
    "name": "Kaiserdom",
    "slug": "kaiserdom",
    "firstLetter": "K"
  },
  {
    "name": "Kalimat",
    "slug": "kalimat",
    "firstLetter": "K"
  },
  {
    "name": "Kamrui",
    "slug": "kamrui",
    "firstLetter": "K"
  },
  {
    "name": "Kangertech",
    "slug": "kangertech",
    "firstLetter": "K"
  },
  {
    "name": "KAO",
    "slug": "kao",
    "firstLetter": "K"
  },
  {
    "name": "Karen Low",
    "slug": "karen-low",
    "firstLetter": "K"
  },
  {
    "name": "Karl Lagerfeld",
    "slug": "karl-lagerfeld",
    "firstLetter": "K"
  },
  {
    "name": "Karma",
    "slug": "karma",
    "firstLetter": "K"
  },
  {
    "name": "Karseell",
    "slug": "karseell",
    "firstLetter": "K"
  },
  {
    "name": "Kate Spade",
    "slug": "kate-spade",
    "firstLetter": "K"
  },
  {
    "name": "Katy Perry",
    "slug": "katy-perry",
    "firstLetter": "K"
  },
  {
    "name": "Keen",
    "slug": "keen",
    "firstLetter": "K"
  },
  {
    "name": "Keepdata",
    "slug": "keepdata",
    "firstLetter": "K"
  },
  {
    "name": "KEF",
    "slug": "kef",
    "firstLetter": "K"
  },
  {
    "name": "Kelme",
    "slug": "kelme",
    "firstLetter": "K"
  },
  {
    "name": "Kemei",
    "slug": "kemei",
    "firstLetter": "K"
  },
  {
    "name": "Kenko",
    "slug": "kenko",
    "firstLetter": "K"
  },
  {
    "name": "Kenneth Cole",
    "slug": "kenneth-cole",
    "firstLetter": "K"
  },
  {
    "name": "Kenwood",
    "slug": "kenwood",
    "firstLetter": "K"
  },
  {
    "name": "Kenzie",
    "slug": "kenzie",
    "firstLetter": "K"
  },
  {
    "name": "Kenzo",
    "slug": "kenzo",
    "firstLetter": "K"
  },
  {
    "name": "Kerastase",
    "slug": "kerastase",
    "firstLetter": "K"
  },
  {
    "name": "Kerasys",
    "slug": "kerasys",
    "firstLetter": "K"
  },
  {
    "name": "Ketel One",
    "slug": "ketel-one",
    "firstLetter": "K"
  },
  {
    "name": "Keune",
    "slug": "keune",
    "firstLetter": "K"
  },
  {
    "name": "Keyroad",
    "slug": "keyroad",
    "firstLetter": "K"
  },
  {
    "name": "Kicker",
    "slug": "kicker",
    "firstLetter": "K"
  },
  {
    "name": "Kidsmania",
    "slug": "kidsmania",
    "firstLetter": "K"
  },
  {
    "name": "Kilian",
    "slug": "kilian",
    "firstLetter": "K"
  },
  {
    "name": "Kinder",
    "slug": "kinder",
    "firstLetter": "K"
  },
  {
    "name": "KingDian",
    "slug": "kingdian",
    "firstLetter": "K"
  },
  {
    "name": "Kingjoy",
    "slug": "kingjoy",
    "firstLetter": "K"
  },
  {
    "name": "Kingston",
    "slug": "kingston",
    "firstLetter": "K"
  },
  {
    "name": "Kipling",
    "slug": "kipling",
    "firstLetter": "K"
  },
  {
    "name": "Kirkland",
    "slug": "kirkland",
    "firstLetter": "K"
  },
  {
    "name": "Kisonli",
    "slug": "kisonli",
    "firstLetter": "K"
  },
  {
    "name": "Kitchenaid",
    "slug": "kitchenaid",
    "firstLetter": "K"
  },
  {
    "name": "Klip Xtreme",
    "slug": "klip-xtreme",
    "firstLetter": "K"
  },
  {
    "name": "Klipsch",
    "slug": "klipsch",
    "firstLetter": "K"
  },
  {
    "name": "Kodak",
    "slug": "kodak",
    "firstLetter": "K"
  },
  {
    "name": "Kolav",
    "slug": "kolav",
    "firstLetter": "K"
  },
  {
    "name": "Kolke",
    "slug": "kolke",
    "firstLetter": "K"
  },
  {
    "name": "Konus",
    "slug": "konus",
    "firstLetter": "K"
  },
  {
    "name": "Korg",
    "slug": "korg",
    "firstLetter": "K"
  },
  {
    "name": "Korkmaz",
    "slug": "korkmaz",
    "firstLetter": "K"
  },
  {
    "name": "Kruger",
    "slug": "kruger",
    "firstLetter": "K"
  },
  {
    "name": "Ksara",
    "slug": "ksara",
    "firstLetter": "K"
  },
  {
    "name": "KTV",
    "slug": "ktv",
    "firstLetter": "K"
  },
  {
    "name": "Kühne",
    "slug": "kuhne",
    "firstLetter": "K"
  },
  {
    "name": "Kvint",
    "slug": "kvint",
    "firstLetter": "K"
  },
  {
    "name": "KwikPen",
    "slug": "kwikpen",
    "firstLetter": "K"
  },
  {
    "name": "Kylie Minogue",
    "slug": "kylie-minogue",
    "firstLetter": "K"
  },
  {
    "name": "L'Affair",
    "slug": "laffair",
    "firstLetter": "L"
  },
  {
    "name": "La Costeña",
    "slug": "la-costena",
    "firstLetter": "L"
  },
  {
    "name": "La Espanola",
    "slug": "la-espanola",
    "firstLetter": "L"
  },
  {
    "name": "La Marsellesa",
    "slug": "la-marsellesa",
    "firstLetter": "L"
  },
  {
    "name": "La Perla",
    "slug": "la-perla",
    "firstLetter": "L"
  },
  {
    "name": "La Rive",
    "slug": "la-rive",
    "firstLetter": "L"
  },
  {
    "name": "La Roche-Posay",
    "slug": "la-roche-posay",
    "firstLetter": "L"
  },
  {
    "name": "La Sevillana",
    "slug": "la-sevillana",
    "firstLetter": "L"
  },
  {
    "name": "Label 5",
    "slug": "label-5",
    "firstLetter": "L"
  },
  {
    "name": "Lacie",
    "slug": "lacie",
    "firstLetter": "L"
  },
  {
    "name": "Lacoste",
    "slug": "lacoste",
    "firstLetter": "L"
  },
  {
    "name": "Lacta",
    "slug": "lacta",
    "firstLetter": "L"
  },
  {
    "name": "Ladyliss",
    "slug": "ladyliss",
    "firstLetter": "L"
  },
  {
    "name": "Lafayette",
    "slug": "lafayette",
    "firstLetter": "L"
  },
  {
    "name": "Lalique",
    "slug": "lalique",
    "firstLetter": "L"
  },
  {
    "name": "Lamborghini",
    "slug": "lamborghini",
    "firstLetter": "L"
  },
  {
    "name": "Lancôme",
    "slug": "lancome",
    "firstLetter": "L"
  },
  {
    "name": "LanderFit",
    "slug": "landerfit",
    "firstLetter": "L"
  },
  {
    "name": "Lanvin",
    "slug": "lanvin",
    "firstLetter": "L"
  },
  {
    "name": "Laowa",
    "slug": "laowa",
    "firstLetter": "L"
  },
  {
    "name": "Larios",
    "slug": "larios",
    "firstLetter": "L"
  },
  {
    "name": "Las Oreiro",
    "slug": "las-oreiro",
    "firstLetter": "L"
  },
  {
    "name": "Las Perdices",
    "slug": "las-perdices",
    "firstLetter": "L"
  },
  {
    "name": "Laverne",
    "slug": "laverne",
    "firstLetter": "L"
  },
  {
    "name": "Lay's",
    "slug": "lays",
    "firstLetter": "L"
  },
  {
    "name": "Le Falconé",
    "slug": "le-falcone",
    "firstLetter": "L"
  },
  {
    "name": "Leatherman",
    "slug": "leatherman",
    "firstLetter": "L"
  },
  {
    "name": "Lee Stafford",
    "slug": "lee-stafford",
    "firstLetter": "L"
  },
  {
    "name": "Lennox",
    "slug": "lennox",
    "firstLetter": "L"
  },
  {
    "name": "Lenovo",
    "slug": "lenovo",
    "firstLetter": "L"
  },
  {
    "name": "Level",
    "slug": "level",
    "firstLetter": "L"
  },
  {
    "name": "Lexar",
    "slug": "lexar",
    "firstLetter": "L"
  },
  {
    "name": "Lexical",
    "slug": "lexical",
    "firstLetter": "L"
  },
  {
    "name": "Lexmark",
    "slug": "lexmark",
    "firstLetter": "L"
  },
  {
    "name": "Lexuznet",
    "slug": "lexuznet",
    "firstLetter": "L"
  },
  {
    "name": "LG",
    "slug": "lg",
    "firstLetter": "L"
  },
  {
    "name": "Lian Li",
    "slug": "lian-li",
    "firstLetter": "L"
  },
  {
    "name": "Licor 43",
    "slug": "licor-43",
    "firstLetter": "L"
  },
  {
    "name": "Life Pod",
    "slug": "life-pod",
    "firstLetter": "L"
  },
  {
    "name": "Lilyeve",
    "slug": "lilyeve",
    "firstLetter": "L"
  },
  {
    "name": "Lindt",
    "slug": "lindt",
    "firstLetter": "L"
  },
  {
    "name": "Linksys",
    "slug": "linksys",
    "firstLetter": "L"
  },
  {
    "name": "Linkworld",
    "slug": "linkworld",
    "firstLetter": "L"
  },
  {
    "name": "Linn Young",
    "slug": "linn-young",
    "firstLetter": "L"
  },
  {
    "name": "Lipoland",
    "slug": "lipoland",
    "firstLetter": "L"
  },
  {
    "name": "Lipoless",
    "slug": "lipoless",
    "firstLetter": "L"
  },
  {
    "name": "Liqua",
    "slug": "liqua",
    "firstLetter": "L"
  },
  {
    "name": "Lizze",
    "slug": "lizze",
    "firstLetter": "L"
  },
  {
    "name": "Loewe",
    "slug": "loewe",
    "firstLetter": "L"
  },
  {
    "name": "Logitech",
    "slug": "logitech",
    "firstLetter": "L"
  },
  {
    "name": "Lolita Lempicka",
    "slug": "lolita-lempicka",
    "firstLetter": "L"
  },
  {
    "name": "Lomani",
    "slug": "lomani",
    "firstLetter": "L"
  },
  {
    "name": "Longchamp",
    "slug": "longchamp",
    "firstLetter": "L"
  },
  {
    "name": "Lonkoom",
    "slug": "lonkoom",
    "firstLetter": "L"
  },
  {
    "name": "Loreal",
    "slug": "loreal",
    "firstLetter": "L"
  },
  {
    "name": "Lorenzo de Agrelo",
    "slug": "lorenzo-de-agrelo",
    "firstLetter": "L"
  },
  {
    "name": "Los Boldos",
    "slug": "los-boldos",
    "firstLetter": "L"
  },
  {
    "name": "Los Nietitos",
    "slug": "los-nietitos",
    "firstLetter": "L"
  },
  {
    "name": "Los Vascos",
    "slug": "los-vascos",
    "firstLetter": "L"
  },
  {
    "name": "Lost Angel",
    "slug": "lost-angel",
    "firstLetter": "L"
  },
  {
    "name": "Lost Vape",
    "slug": "lost-vape",
    "firstLetter": "L"
  },
  {
    "name": "Lotte",
    "slug": "lotte",
    "firstLetter": "L"
  },
  {
    "name": "Lotto",
    "slug": "lotto",
    "firstLetter": "L"
  },
  {
    "name": "Louis Varel",
    "slug": "louis-varel",
    "firstLetter": "L"
  },
  {
    "name": "Louis Vuitton",
    "slug": "louis-vuitton",
    "firstLetter": "L"
  },
  {
    "name": "Lovali",
    "slug": "lovali",
    "firstLetter": "L"
  },
  {
    "name": "Love Collection",
    "slug": "love-collection",
    "firstLetter": "L"
  },
  {
    "name": "LPDO",
    "slug": "lpdo",
    "firstLetter": "L"
  },
  {
    "name": "LS2",
    "slug": "ls2",
    "firstLetter": "L"
  },
  {
    "name": "LucidSound",
    "slug": "lucidsound",
    "firstLetter": "L"
  },
  {
    "name": "Luffbar",
    "slug": "luffbar",
    "firstLetter": "L"
  },
  {
    "name": "Luigi Bosca",
    "slug": "luigi-bosca",
    "firstLetter": "L"
  },
  {
    "name": "Luis Felipe Edwards",
    "slug": "luis-felipe-edwards",
    "firstLetter": "L"
  },
  {
    "name": "Lulu Castagnette",
    "slug": "lulu-castagnette",
    "firstLetter": "L"
  },
  {
    "name": "LUO",
    "slug": "luo",
    "firstLetter": "L"
  },
  {
    "name": "Luxardo",
    "slug": "luxardo",
    "firstLetter": "L"
  },
  {
    "name": "Luxshav",
    "slug": "luxshav",
    "firstLetter": "L"
  },
  {
    "name": "Lydsto",
    "slug": "lydsto",
    "firstLetter": "L"
  },
  {
    "name": "M.A.C",
    "slug": "mac",
    "firstLetter": "M"
  },
  {
    "name": "M1",
    "slug": "m1",
    "firstLetter": "M"
  },
  {
    "name": "Mabe",
    "slug": "mabe",
    "firstLetter": "M"
  },
  {
    "name": "MAC Cosmetics",
    "slug": "mac-cosmetics",
    "firstLetter": "M"
  },
  {
    "name": "MacArthur's",
    "slug": "macarthurs",
    "firstLetter": "M"
  },
  {
    "name": "Macrovip",
    "slug": "macrovip",
    "firstLetter": "M"
  },
  {
    "name": "Macroway",
    "slug": "macroway",
    "firstLetter": "M"
  },
  {
    "name": "Mad Hatter",
    "slug": "mad-hatter",
    "firstLetter": "M"
  },
  {
    "name": "Madman",
    "slug": "madman",
    "firstLetter": "M"
  },
  {
    "name": "Madonna",
    "slug": "madonna",
    "firstLetter": "M"
  },
  {
    "name": "Magefesa",
    "slug": "magefesa",
    "firstLetter": "M"
  },
  {
    "name": "Magna",
    "slug": "magna",
    "firstLetter": "M"
  },
  {
    "name": "Magnavox",
    "slug": "magnavox",
    "firstLetter": "M"
  },
  {
    "name": "Mahou",
    "slug": "mahou",
    "firstLetter": "M"
  },
  {
    "name": "Maison Alhambra",
    "slug": "maison-alhambra",
    "firstLetter": "M"
  },
  {
    "name": "Maison Asrar",
    "slug": "maison-asrar",
    "firstLetter": "M"
  },
  {
    "name": "Maison de Milan",
    "slug": "maison-de-milan",
    "firstLetter": "M"
  },
  {
    "name": "Maison Micallef",
    "slug": "maison-micallef",
    "firstLetter": "M"
  },
  {
    "name": "Malizia",
    "slug": "malizia",
    "firstLetter": "M"
  },
  {
    "name": "MAM",
    "slug": "mam",
    "firstLetter": "M"
  },
  {
    "name": "Mancer",
    "slug": "mancer",
    "firstLetter": "M"
  },
  {
    "name": "Mancera",
    "slug": "mancera",
    "firstLetter": "M"
  },
  {
    "name": "Mandarina Duck",
    "slug": "mandarina-duck",
    "firstLetter": "M"
  },
  {
    "name": "Mangoo",
    "slug": "mangoo",
    "firstLetter": "M"
  },
  {
    "name": "Manhattan",
    "slug": "manhattan",
    "firstLetter": "M"
  },
  {
    "name": "Mannatech",
    "slug": "mannatech",
    "firstLetter": "M"
  },
  {
    "name": "Mapex",
    "slug": "mapex",
    "firstLetter": "M"
  },
  {
    "name": "Marc Jacobs",
    "slug": "marc-jacobs",
    "firstLetter": "M"
  },
  {
    "name": "Marc Joseph",
    "slug": "marc-joseph",
    "firstLetter": "M"
  },
  {
    "name": "Marie Brizard",
    "slug": "marie-brizard",
    "firstLetter": "M"
  },
  {
    "name": "Marina De Bourbon",
    "slug": "marina-de-bourbon",
    "firstLetter": "M"
  },
  {
    "name": "Marine",
    "slug": "marine",
    "firstLetter": "M"
  },
  {
    "name": "Markvision",
    "slug": "markvision",
    "firstLetter": "M"
  },
  {
    "name": "Marqués de Riscal",
    "slug": "marques-de-riscal",
    "firstLetter": "M"
  },
  {
    "name": "Marshall",
    "slug": "marshall",
    "firstLetter": "M"
  },
  {
    "name": "Marson",
    "slug": "marson",
    "firstLetter": "M"
  },
  {
    "name": "Marsriva",
    "slug": "marsriva",
    "firstLetter": "M"
  },
  {
    "name": "Martin Sesse",
    "slug": "martin-sesse",
    "firstLetter": "M"
  },
  {
    "name": "Maruri",
    "slug": "maruri",
    "firstLetter": "M"
  },
  {
    "name": "Marvel",
    "slug": "marvel",
    "firstLetter": "M"
  },
  {
    "name": "Marvo",
    "slug": "marvo",
    "firstLetter": "M"
  },
  {
    "name": "Marxzelle",
    "slug": "marxzelle",
    "firstLetter": "M"
  },
  {
    "name": "Maryaj",
    "slug": "maryaj",
    "firstLetter": "M"
  },
  {
    "name": "Maskking",
    "slug": "maskking",
    "firstLetter": "M"
  },
  {
    "name": "Massaluca",
    "slug": "massaluca",
    "firstLetter": "M"
  },
  {
    "name": "Master's",
    "slug": "masters",
    "firstLetter": "M"
  },
  {
    "name": "Matin Martin",
    "slug": "matin-martin",
    "firstLetter": "M"
  },
  {
    "name": "Matrix",
    "slug": "matrix",
    "firstLetter": "M"
  },
  {
    "name": "Mauboussin",
    "slug": "mauboussin",
    "firstLetter": "M"
  },
  {
    "name": "Mawwal",
    "slug": "mawwal",
    "firstLetter": "M"
  },
  {
    "name": "Maxbar",
    "slug": "maxbar",
    "firstLetter": "M"
  },
  {
    "name": "Maxell",
    "slug": "maxell",
    "firstLetter": "M"
  },
  {
    "name": "Maxon",
    "slug": "maxon",
    "firstLetter": "M"
  },
  {
    "name": "MaxRacer",
    "slug": "maxracer",
    "firstLetter": "M"
  },
  {
    "name": "Maybelline",
    "slug": "maybelline",
    "firstLetter": "M"
  },
  {
    "name": "Mayos",
    "slug": "mayos",
    "firstLetter": "M"
  },
  {
    "name": "Mazzei",
    "slug": "mazzei",
    "firstLetter": "M"
  },
  {
    "name": "MB",
    "slug": "mb",
    "firstLetter": "M"
  },
  {
    "name": "MB Parfums",
    "slug": "mb-parfums",
    "firstLetter": "M"
  },
  {
    "name": "MC Cartney",
    "slug": "mc-cartney",
    "firstLetter": "M"
  },
  {
    "name": "McCormick",
    "slug": "mccormick",
    "firstLetter": "M"
  },
  {
    "name": "Mcdodo",
    "slug": "mcdodo",
    "firstLetter": "M"
  },
  {
    "name": "Medicube",
    "slug": "medicube",
    "firstLetter": "M"
  },
  {
    "name": "Mega Star",
    "slug": "mega-star",
    "firstLetter": "M"
  },
  {
    "name": "Megabass",
    "slug": "megabass",
    "firstLetter": "M"
  },
  {
    "name": "MegaBox",
    "slug": "megabox",
    "firstLetter": "M"
  },
  {
    "name": "Megir",
    "slug": "megir",
    "firstLetter": "M"
  },
  {
    "name": "Meike",
    "slug": "meike",
    "firstLetter": "M"
  },
  {
    "name": "Mekka",
    "slug": "mekka",
    "firstLetter": "M"
  },
  {
    "name": "Memo",
    "slug": "memo",
    "firstLetter": "M"
  },
  {
    "name": "Memwa",
    "slug": "memwa",
    "firstLetter": "M"
  },
  {
    "name": "Mentos",
    "slug": "mentos",
    "firstLetter": "M"
  },
  {
    "name": "Meoflix",
    "slug": "meoflix",
    "firstLetter": "M"
  },
  {
    "name": "Mercedes-Benz",
    "slug": "mercedes-benz",
    "firstLetter": "M"
  },
  {
    "name": "Mercusys",
    "slug": "mercusys",
    "firstLetter": "M"
  },
  {
    "name": "Merkury",
    "slug": "merkury",
    "firstLetter": "M"
  },
  {
    "name": "Merrell",
    "slug": "merrell",
    "firstLetter": "M"
  },
  {
    "name": "Meta",
    "slug": "meta",
    "firstLetter": "M"
  },
  {
    "name": "MG Spirit",
    "slug": "mg-spirit",
    "firstLetter": "M"
  },
  {
    "name": "Mibo",
    "slug": "mibo",
    "firstLetter": "M"
  },
  {
    "name": "Mibro",
    "slug": "mibro",
    "firstLetter": "M"
  },
  {
    "name": "Michael Kors",
    "slug": "michael-kors",
    "firstLetter": "M"
  },
  {
    "name": "Microfins",
    "slug": "microfins",
    "firstLetter": "M"
  },
  {
    "name": "Microwear",
    "slug": "microwear",
    "firstLetter": "M"
  },
  {
    "name": "Midea",
    "slug": "midea",
    "firstLetter": "M"
  },
  {
    "name": "Midi",
    "slug": "midi",
    "firstLetter": "M"
  },
  {
    "name": "Midia",
    "slug": "midia",
    "firstLetter": "M"
  },
  {
    "name": "Midland",
    "slug": "midland",
    "firstLetter": "M"
  },
  {
    "name": "MikroTik",
    "slug": "mikrotik",
    "firstLetter": "M"
  },
  {
    "name": "Milan",
    "slug": "milan",
    "firstLetter": "M"
  },
  {
    "name": "Milani",
    "slug": "milani",
    "firstLetter": "M"
  },
  {
    "name": "Milestone",
    "slug": "milestone",
    "firstLetter": "M"
  },
  {
    "name": "Milka",
    "slug": "milka",
    "firstLetter": "M"
  },
  {
    "name": "Miller",
    "slug": "miller",
    "firstLetter": "M"
  },
  {
    "name": "Ming Chu",
    "slug": "ming-chu",
    "firstLetter": "M"
  },
  {
    "name": "Miracle Box",
    "slug": "miracle-box",
    "firstLetter": "M"
  },
  {
    "name": "Miracurl",
    "slug": "miracurl",
    "firstLetter": "M"
  },
  {
    "name": "Mirada",
    "slug": "mirada",
    "firstLetter": "M"
  },
  {
    "name": "Mirage",
    "slug": "mirage",
    "firstLetter": "M"
  },
  {
    "name": "Miss Rôse",
    "slug": "miss-rose",
    "firstLetter": "M"
  },
  {
    "name": "Missha",
    "slug": "missha",
    "firstLetter": "M"
  },
  {
    "name": "Missoni",
    "slug": "missoni",
    "firstLetter": "M"
  },
  {
    "name": "Mister Potato",
    "slug": "mister-potato",
    "firstLetter": "M"
  },
  {
    "name": "Mitsubishi",
    "slug": "mitsubishi",
    "firstLetter": "M"
  },
  {
    "name": "Mitsuca",
    "slug": "mitsuca",
    "firstLetter": "M"
  },
  {
    "name": "Mitsuo",
    "slug": "mitsuo",
    "firstLetter": "M"
  },
  {
    "name": "Mizuno",
    "slug": "mizuno",
    "firstLetter": "M"
  },
  {
    "name": "Modyafa",
    "slug": "modyafa",
    "firstLetter": "M"
  },
  {
    "name": "Mojo",
    "slug": "mojo",
    "firstLetter": "M"
  },
  {
    "name": "Molimix",
    "slug": "molimix",
    "firstLetter": "M"
  },
  {
    "name": "Molyneux",
    "slug": "molyneux",
    "firstLetter": "M"
  },
  {
    "name": "MOM",
    "slug": "mom",
    "firstLetter": "M"
  },
  {
    "name": "Mon Bar",
    "slug": "mon-bar",
    "firstLetter": "M"
  },
  {
    "name": "Moncler",
    "slug": "moncler",
    "firstLetter": "M"
  },
  {
    "name": "Mondial",
    "slug": "mondial",
    "firstLetter": "M"
  },
  {
    "name": "Monkey Shoulder",
    "slug": "monkey-shoulder",
    "firstLetter": "M"
  },
  {
    "name": "Monster",
    "slug": "monster",
    "firstLetter": "M"
  },
  {
    "name": "Monster Energy",
    "slug": "monster-energy",
    "firstLetter": "M"
  },
  {
    "name": "Montale",
    "slug": "montale",
    "firstLetter": "M"
  },
  {
    "name": "Montana",
    "slug": "montana",
    "firstLetter": "M"
  },
  {
    "name": "Montblanc",
    "slug": "montblanc",
    "firstLetter": "M"
  },
  {
    "name": "Montecampo",
    "slug": "montecampo",
    "firstLetter": "M"
  },
  {
    "name": "Montes",
    "slug": "montes",
    "firstLetter": "M"
  },
  {
    "name": "Montwood",
    "slug": "montwood",
    "firstLetter": "M"
  },
  {
    "name": "More Fitness",
    "slug": "more-fitness",
    "firstLetter": "M"
  },
  {
    "name": "Moretti",
    "slug": "moretti",
    "firstLetter": "M"
  },
  {
    "name": "Morgan",
    "slug": "morgan",
    "firstLetter": "M"
  },
  {
    "name": "Moschino",
    "slug": "moschino",
    "firstLetter": "M"
  },
  {
    "name": "Moti",
    "slug": "moti",
    "firstLetter": "M"
  },
  {
    "name": "Motorola",
    "slug": "motorola",
    "firstLetter": "M"
  },
  {
    "name": "Moulinex",
    "slug": "moulinex",
    "firstLetter": "M"
  },
  {
    "name": "Mount Gay",
    "slug": "mount-gay",
    "firstLetter": "M"
  },
  {
    "name": "Mox",
    "slug": "mox",
    "firstLetter": "M"
  },
  {
    "name": "Moxom",
    "slug": "moxom",
    "firstLetter": "M"
  },
  {
    "name": "MR. Custard",
    "slug": "mr-custard",
    "firstLetter": "M"
  },
  {
    "name": "MR. Freeze",
    "slug": "mr-freeze",
    "firstLetter": "M"
  },
  {
    "name": "MR. Yoop",
    "slug": "mr-yoop",
    "firstLetter": "M"
  },
  {
    "name": "MSI",
    "slug": "msi",
    "firstLetter": "M"
  },
  {
    "name": "MT Helmets",
    "slug": "mt-helmets",
    "firstLetter": "M"
  },
  {
    "name": "Mtek",
    "slug": "mtek",
    "firstLetter": "M"
  },
  {
    "name": "MTX",
    "slug": "mtx",
    "firstLetter": "M"
  },
  {
    "name": "Muela",
    "slug": "muela",
    "firstLetter": "M"
  },
  {
    "name": "Multigraph",
    "slug": "multigraph",
    "firstLetter": "M"
  },
  {
    "name": "Multilaser",
    "slug": "multilaser",
    "firstLetter": "M"
  },
  {
    "name": "Multisat",
    "slug": "multisat",
    "firstLetter": "M"
  },
  {
    "name": "Munich",
    "slug": "munich",
    "firstLetter": "M"
  },
  {
    "name": "MuscleTech",
    "slug": "muscletech",
    "firstLetter": "M"
  },
  {
    "name": "Mustang",
    "slug": "mustang",
    "firstLetter": "M"
  },
  {
    "name": "MXQ",
    "slug": "mxq",
    "firstLetter": "M"
  },
  {
    "name": "Nabeel",
    "slug": "nabeel",
    "firstLetter": "N"
  },
  {
    "name": "Nacon",
    "slug": "nacon",
    "firstLetter": "N"
  },
  {
    "name": "Nadia Ferreira",
    "slug": "nadia-ferreira",
    "firstLetter": "N"
  },
  {
    "name": "Nakamichi",
    "slug": "nakamichi",
    "firstLetter": "N"
  },
  {
    "name": "Naked",
    "slug": "naked",
    "firstLetter": "N"
  },
  {
    "name": "Nanine",
    "slug": "nanine",
    "firstLetter": "N"
  },
  {
    "name": "Nanlite",
    "slug": "nanlite",
    "firstLetter": "N"
  },
  {
    "name": "Napoli",
    "slug": "napoli",
    "firstLetter": "N"
  },
  {
    "name": "Nappo",
    "slug": "nappo",
    "firstLetter": "N"
  },
  {
    "name": "Narciso Rodriguez",
    "slug": "narciso-rodriguez",
    "firstLetter": "N"
  },
  {
    "name": "Narken",
    "slug": "narken",
    "firstLetter": "N"
  },
  {
    "name": "Nask",
    "slug": "nask",
    "firstLetter": "N"
  },
  {
    "name": "Nasma",
    "slug": "nasma",
    "firstLetter": "N"
  },
  {
    "name": "Nasty Juice",
    "slug": "nasty-juice",
    "firstLetter": "N"
  },
  {
    "name": "Natrol",
    "slug": "natrol",
    "firstLetter": "N"
  },
  {
    "name": "Natural Honey",
    "slug": "natural-honey",
    "firstLetter": "N"
  },
  {
    "name": "Nature's Truth",
    "slug": "natures-truth",
    "firstLetter": "N"
  },
  {
    "name": "Nautica",
    "slug": "nautica",
    "firstLetter": "N"
  },
  {
    "name": "Navarro Correas",
    "slug": "navarro-correas",
    "firstLetter": "N"
  },
  {
    "name": "Navee",
    "slug": "navee",
    "firstLetter": "N"
  },
  {
    "name": "NAY",
    "slug": "nay",
    "firstLetter": "N"
  },
  {
    "name": "Nazabox",
    "slug": "nazabox",
    "firstLetter": "N"
  },
  {
    "name": "Nazareno Gabrielli",
    "slug": "nazareno-gabrielli",
    "firstLetter": "N"
  },
  {
    "name": "NBA",
    "slug": "nba",
    "firstLetter": "N"
  },
  {
    "name": "NComputing",
    "slug": "ncomputing",
    "firstLetter": "N"
  },
  {
    "name": "NEC",
    "slug": "nec",
    "firstLetter": "N"
  },
  {
    "name": "Nerds",
    "slug": "nerds",
    "firstLetter": "N"
  },
  {
    "name": "Nescafé",
    "slug": "nescafe",
    "firstLetter": "N"
  },
  {
    "name": "Nestle",
    "slug": "nestle",
    "firstLetter": "N"
  },
  {
    "name": "Net Line",
    "slug": "net-line",
    "firstLetter": "N"
  },
  {
    "name": "Netis",
    "slug": "netis",
    "firstLetter": "N"
  },
  {
    "name": "Neugebauer",
    "slug": "neugebauer",
    "firstLetter": "N"
  },
  {
    "name": "Neutrik",
    "slug": "neutrik",
    "firstLetter": "N"
  },
  {
    "name": "Neutrogena",
    "slug": "neutrogena",
    "firstLetter": "N"
  },
  {
    "name": "Nevoks",
    "slug": "nevoks",
    "firstLetter": "N"
  },
  {
    "name": "New Balance",
    "slug": "new-balance",
    "firstLetter": "N"
  },
  {
    "name": "New Brand",
    "slug": "new-brand",
    "firstLetter": "N"
  },
  {
    "name": "New Color",
    "slug": "new-color",
    "firstLetter": "N"
  },
  {
    "name": "Nexa",
    "slug": "nexa",
    "firstLetter": "N"
  },
  {
    "name": "Nicasia",
    "slug": "nicasia",
    "firstLetter": "N"
  },
  {
    "name": "Nice Paris",
    "slug": "nice-paris",
    "firstLetter": "N"
  },
  {
    "name": "Nicolas Feuillatte",
    "slug": "nicolas-feuillatte",
    "firstLetter": "N"
  },
  {
    "name": "Nikbar",
    "slug": "nikbar",
    "firstLetter": "N"
  },
  {
    "name": "Nike",
    "slug": "nike",
    "firstLetter": "N"
  },
  {
    "name": "Nikon",
    "slug": "nikon",
    "firstLetter": "N"
  },
  {
    "name": "Nina Ricci",
    "slug": "nina-ricci",
    "firstLetter": "N"
  },
  {
    "name": "Ninja",
    "slug": "ninja",
    "firstLetter": "N"
  },
  {
    "name": "Nishane",
    "slug": "nishane",
    "firstLetter": "N"
  },
  {
    "name": "Nitecore",
    "slug": "nitecore",
    "firstLetter": "N"
  },
  {
    "name": "Nivea",
    "slug": "nivea",
    "firstLetter": "N"
  },
  {
    "name": "Nokia",
    "slug": "nokia",
    "firstLetter": "N"
  },
  {
    "name": "Nomu",
    "slug": "nomu",
    "firstLetter": "N"
  },
  {
    "name": "Nongshim",
    "slug": "nongshim",
    "firstLetter": "N"
  },
  {
    "name": "NOW",
    "slug": "now",
    "firstLetter": "N"
  },
  {
    "name": "Nox",
    "slug": "nox",
    "firstLetter": "N"
  },
  {
    "name": "Numark",
    "slug": "numark",
    "firstLetter": "N"
  },
  {
    "name": "Nuspa",
    "slug": "nuspa",
    "firstLetter": "N"
  },
  {
    "name": "Nusuk",
    "slug": "nusuk",
    "firstLetter": "N"
  },
  {
    "name": "Nutrata",
    "slug": "nutrata",
    "firstLetter": "N"
  },
  {
    "name": "Nutrex",
    "slug": "nutrex",
    "firstLetter": "N"
  },
  {
    "name": "Nuu",
    "slug": "nuu",
    "firstLetter": "N"
  },
  {
    "name": "Nuvo",
    "slug": "nuvo",
    "firstLetter": "N"
  },
  {
    "name": "Nvidia",
    "slug": "nvidia",
    "firstLetter": "N"
  },
  {
    "name": "Nylaa",
    "slug": "nylaa",
    "firstLetter": "N"
  },
  {
    "name": "Nyx",
    "slug": "nyx",
    "firstLetter": "N"
  },
  {
    "name": "O'Mara's",
    "slug": "omaras",
    "firstLetter": "O"
  },
  {
    "name": "Oakley",
    "slug": "oakley",
    "firstLetter": "O"
  },
  {
    "name": "Oculus",
    "slug": "oculus",
    "firstLetter": "O"
  },
  {
    "name": "OKF",
    "slug": "okf",
    "firstLetter": "O"
  },
  {
    "name": "Olaplex",
    "slug": "olaplex",
    "firstLetter": "O"
  },
  {
    "name": "Old Parr",
    "slug": "old-parr",
    "firstLetter": "O"
  },
  {
    "name": "Ole Smoky",
    "slug": "ole-smoky",
    "firstLetter": "O"
  },
  {
    "name": "Olitalia",
    "slug": "olitalia",
    "firstLetter": "O"
  },
  {
    "name": "Olmas",
    "slug": "olmas",
    "firstLetter": "O"
  },
  {
    "name": "Olympikus",
    "slug": "olympikus",
    "firstLetter": "O"
  },
  {
    "name": "Olympus",
    "slug": "olympus",
    "firstLetter": "O"
  },
  {
    "name": "Omerta",
    "slug": "omerta",
    "firstLetter": "O"
  },
  {
    "name": "Omron",
    "slug": "omron",
    "firstLetter": "O"
  },
  {
    "name": "On Running",
    "slug": "on-running",
    "firstLetter": "O"
  },
  {
    "name": "On Tv",
    "slug": "on-tv",
    "firstLetter": "O"
  },
  {
    "name": "OnBongo",
    "slug": "onbongo",
    "firstLetter": "O"
  },
  {
    "name": "Onduo",
    "slug": "onduo",
    "firstLetter": "O"
  },
  {
    "name": "One",
    "slug": "one",
    "firstLetter": "O"
  },
  {
    "name": "One Direction",
    "slug": "one-direction",
    "firstLetter": "O"
  },
  {
    "name": "Oneodio",
    "slug": "oneodio",
    "firstLetter": "O"
  },
  {
    "name": "Onida",
    "slug": "onida",
    "firstLetter": "O"
  },
  {
    "name": "Onikuma",
    "slug": "onikuma",
    "firstLetter": "O"
  },
  {
    "name": "Onix",
    "slug": "onix",
    "firstLetter": "O"
  },
  {
    "name": "Onkyo",
    "slug": "onkyo",
    "firstLetter": "O"
  },
  {
    "name": "Onled",
    "slug": "onled",
    "firstLetter": "O"
  },
  {
    "name": "Only",
    "slug": "only",
    "firstLetter": "O"
  },
  {
    "name": "Onsound",
    "slug": "onsound",
    "firstLetter": "O"
  },
  {
    "name": "Openbox",
    "slug": "openbox",
    "firstLetter": "O"
  },
  {
    "name": "Oppo",
    "slug": "oppo",
    "firstLetter": "O"
  },
  {
    "name": "Optimum Nutrition",
    "slug": "optimum-nutrition",
    "firstLetter": "O"
  },
  {
    "name": "Optoma",
    "slug": "optoma",
    "firstLetter": "O"
  },
  {
    "name": "Oraimo",
    "slug": "oraimo",
    "firstLetter": "O"
  },
  {
    "name": "Oreo",
    "slug": "oreo",
    "firstLetter": "O"
  },
  {
    "name": "Orientica",
    "slug": "orientica",
    "firstLetter": "O"
  },
  {
    "name": "ORO",
    "slug": "oro",
    "firstLetter": "O"
  },
  {
    "name": "Oscar De La Renta",
    "slug": "oscar-de-la-renta",
    "firstLetter": "O"
  },
  {
    "name": "Ossion",
    "slug": "ossion",
    "firstLetter": "O"
  },
  {
    "name": "Oster",
    "slug": "oster",
    "firstLetter": "O"
  },
  {
    "name": "Ottocast",
    "slug": "ottocast",
    "firstLetter": "O"
  },
  {
    "name": "Ottoni",
    "slug": "ottoni",
    "firstLetter": "O"
  },
  {
    "name": "Oukitel",
    "slug": "oukitel",
    "firstLetter": "O"
  },
  {
    "name": "Oura",
    "slug": "oura",
    "firstLetter": "O"
  },
  {
    "name": "Oxbar",
    "slug": "oxbar",
    "firstLetter": "O"
  },
  {
    "name": "Oxdog",
    "slug": "oxdog",
    "firstLetter": "O"
  },
  {
    "name": "Oxva",
    "slug": "oxva",
    "firstLetter": "O"
  },
  {
    "name": "Pacha Ibiza",
    "slug": "pacha-ibiza",
    "firstLetter": "P"
  },
  {
    "name": "Pachuca",
    "slug": "pachuca",
    "firstLetter": "P"
  },
  {
    "name": "Palazzo",
    "slug": "palazzo",
    "firstLetter": "P"
  },
  {
    "name": "Palit",
    "slug": "palit",
    "firstLetter": "P"
  },
  {
    "name": "Palmer's",
    "slug": "palmers",
    "firstLetter": "P"
  },
  {
    "name": "Paloma Picasso",
    "slug": "paloma-picasso",
    "firstLetter": "P"
  },
  {
    "name": "Pamapic",
    "slug": "pamapic",
    "firstLetter": "P"
  },
  {
    "name": "Panamax",
    "slug": "panamax",
    "firstLetter": "P"
  },
  {
    "name": "Panasonic",
    "slug": "panasonic",
    "firstLetter": "P"
  },
  {
    "name": "Panchitos",
    "slug": "panchitos",
    "firstLetter": "P"
  },
  {
    "name": "Pantene",
    "slug": "pantene",
    "firstLetter": "P"
  },
  {
    "name": "Pantum",
    "slug": "pantum",
    "firstLetter": "P"
  },
  {
    "name": "Pardus",
    "slug": "pardus",
    "firstLetter": "P"
  },
  {
    "name": "Parfums de Marly",
    "slug": "parfums-de-marly",
    "firstLetter": "P"
  },
  {
    "name": "Paris Bleu",
    "slug": "paris-bleu",
    "firstLetter": "P"
  },
  {
    "name": "Paris Corner",
    "slug": "paris-corner",
    "firstLetter": "P"
  },
  {
    "name": "Paris Hilton",
    "slug": "paris-hilton",
    "firstLetter": "P"
  },
  {
    "name": "Paris Royale",
    "slug": "paris-royale",
    "firstLetter": "P"
  },
  {
    "name": "Parkers",
    "slug": "parkers",
    "firstLetter": "P"
  },
  {
    "name": "Parlux",
    "slug": "parlux",
    "firstLetter": "P"
  },
  {
    "name": "Parrot",
    "slug": "parrot",
    "firstLetter": "P"
  },
  {
    "name": "Pascal Morabito",
    "slug": "pascal-morabito",
    "firstLetter": "P"
  },
  {
    "name": "Patagonia",
    "slug": "patagonia",
    "firstLetter": "P"
  },
  {
    "name": "Patriot",
    "slug": "patriot",
    "firstLetter": "P"
  },
  {
    "name": "Patrón",
    "slug": "patron",
    "firstLetter": "P"
  },
  {
    "name": "Paul Vess",
    "slug": "paul-vess",
    "firstLetter": "P"
  },
  {
    "name": "Paulaner",
    "slug": "paulaner",
    "firstLetter": "P"
  },
  {
    "name": "PCChips",
    "slug": "pcchips",
    "firstLetter": "P"
  },
  {
    "name": "Peavey",
    "slug": "peavey",
    "firstLetter": "P"
  },
  {
    "name": "Pechery",
    "slug": "pechery",
    "firstLetter": "P"
  },
  {
    "name": "Pedro Del Hierro",
    "slug": "pedro-del-hierro",
    "firstLetter": "P"
  },
  {
    "name": "Pelco",
    "slug": "pelco",
    "firstLetter": "P"
  },
  {
    "name": "Pelonis",
    "slug": "pelonis",
    "firstLetter": "P"
  },
  {
    "name": "Pendora Scents",
    "slug": "pendora-scents",
    "firstLetter": "P"
  },
  {
    "name": "Pentax",
    "slug": "pentax",
    "firstLetter": "P"
  },
  {
    "name": "Pepe Jeans",
    "slug": "pepe-jeans",
    "firstLetter": "P"
  },
  {
    "name": "Peroni",
    "slug": "peroni",
    "firstLetter": "P"
  },
  {
    "name": "Perrier Jouët",
    "slug": "perrier-jouet",
    "firstLetter": "P"
  },
  {
    "name": "Perry Ellis",
    "slug": "perry-ellis",
    "firstLetter": "P"
  },
  {
    "name": "Petite Jolie",
    "slug": "petite-jolie",
    "firstLetter": "P"
  },
  {
    "name": "Phantom",
    "slug": "phantom",
    "firstLetter": "P"
  },
  {
    "name": "Philco",
    "slug": "philco",
    "firstLetter": "P"
  },
  {
    "name": "Philipp Plein Sport",
    "slug": "philipp-plein-sport",
    "firstLetter": "P"
  },
  {
    "name": "Philips",
    "slug": "philips",
    "firstLetter": "P"
  },
  {
    "name": "Pierre Bernard",
    "slug": "pierre-bernard",
    "firstLetter": "P"
  },
  {
    "name": "Pierre Cardin",
    "slug": "pierre-cardin",
    "firstLetter": "P"
  },
  {
    "name": "Pineng",
    "slug": "pineng",
    "firstLetter": "P"
  },
  {
    "name": "Pink Sugar",
    "slug": "pink-sugar",
    "firstLetter": "P"
  },
  {
    "name": "Pino Silvestre",
    "slug": "pino-silvestre",
    "firstLetter": "P"
  },
  {
    "name": "Pintamax",
    "slug": "pintamax",
    "firstLetter": "P"
  },
  {
    "name": "Pioneer",
    "slug": "pioneer",
    "firstLetter": "P"
  },
  {
    "name": "Piping Rock",
    "slug": "piping-rock",
    "firstLetter": "P"
  },
  {
    "name": "Pirelli",
    "slug": "pirelli",
    "firstLetter": "P"
  },
  {
    "name": "Pix Bar",
    "slug": "pix-bar",
    "firstLetter": "P"
  },
  {
    "name": "Plaud",
    "slug": "plaud",
    "firstLetter": "P"
  },
  {
    "name": "Play Game",
    "slug": "play-game",
    "firstLetter": "P"
  },
  {
    "name": "PNT",
    "slug": "pnt",
    "firstLetter": "P"
  },
  {
    "name": "PNY",
    "slug": "pny",
    "firstLetter": "P"
  },
  {
    "name": "Polar",
    "slug": "polar",
    "firstLetter": "P"
  },
  {
    "name": "Polaroid",
    "slug": "polaroid",
    "firstLetter": "P"
  },
  {
    "name": "Poliakov",
    "slug": "poliakov",
    "firstLetter": "P"
  },
  {
    "name": "Police",
    "slug": "police",
    "firstLetter": "P"
  },
  {
    "name": "Polo",
    "slug": "polo",
    "firstLetter": "P"
  },
  {
    "name": "Polycom",
    "slug": "polycom",
    "firstLetter": "P"
  },
  {
    "name": "Ponche Kuba",
    "slug": "ponche-kuba",
    "firstLetter": "P"
  },
  {
    "name": "Pop TV",
    "slug": "pop-tv",
    "firstLetter": "P"
  },
  {
    "name": "Porsche Design",
    "slug": "porsche-design",
    "firstLetter": "P"
  },
  {
    "name": "Porto Cruz",
    "slug": "porto-cruz",
    "firstLetter": "P"
  },
  {
    "name": "Positivo",
    "slug": "positivo",
    "firstLetter": "P"
  },
  {
    "name": "Positron",
    "slug": "positron",
    "firstLetter": "P"
  },
  {
    "name": "Posonic",
    "slug": "posonic",
    "firstLetter": "P"
  },
  {
    "name": "Potato King",
    "slug": "potato-king",
    "firstLetter": "P"
  },
  {
    "name": "PowerA",
    "slug": "powera",
    "firstLetter": "P"
  },
  {
    "name": "PowerColor",
    "slug": "powercolor",
    "firstLetter": "P"
  },
  {
    "name": "Powerpack",
    "slug": "powerpack",
    "firstLetter": "P"
  },
  {
    "name": "PowerTrac",
    "slug": "powertrac",
    "firstLetter": "P"
  },
  {
    "name": "Powkiddy",
    "slug": "powkiddy",
    "firstLetter": "P"
  },
  {
    "name": "Prada",
    "slug": "prada",
    "firstLetter": "P"
  },
  {
    "name": "Pravda",
    "slug": "pravda",
    "firstLetter": "P"
  },
  {
    "name": "Presonus",
    "slug": "presonus",
    "firstLetter": "P"
  },
  {
    "name": "Prestigious Parfums",
    "slug": "prestigious-parfums",
    "firstLetter": "P"
  },
  {
    "name": "Prima Chic",
    "slug": "prima-chic",
    "firstLetter": "P"
  },
  {
    "name": "Pringles",
    "slug": "pringles",
    "firstLetter": "P"
  },
  {
    "name": "Pro Mountain",
    "slug": "pro-mountain",
    "firstLetter": "P"
  },
  {
    "name": "Pro-Move",
    "slug": "pro-move",
    "firstLetter": "P"
  },
  {
    "name": "Probox",
    "slug": "probox",
    "firstLetter": "P"
  },
  {
    "name": "Pronol",
    "slug": "pronol",
    "firstLetter": "P"
  },
  {
    "name": "Prosper",
    "slug": "prosper",
    "firstLetter": "P"
  },
  {
    "name": "Protos",
    "slug": "protos",
    "firstLetter": "P"
  },
  {
    "name": "Puccini",
    "slug": "puccini",
    "firstLetter": "P"
  },
  {
    "name": "Puerto de Indias",
    "slug": "puerto-de-indias",
    "firstLetter": "P"
  },
  {
    "name": "Puff Mamma",
    "slug": "puff-mamma",
    "firstLetter": "P"
  },
  {
    "name": "Pulenta",
    "slug": "pulenta",
    "firstLetter": "P"
  },
  {
    "name": "Pulsar",
    "slug": "pulsar",
    "firstLetter": "P"
  },
  {
    "name": "Puma",
    "slug": "puma",
    "firstLetter": "P"
  },
  {
    "name": "Punta Ballena",
    "slug": "punta-ballena",
    "firstLetter": "P"
  },
  {
    "name": "Pyne Pod",
    "slug": "pyne-pod",
    "firstLetter": "P"
  },
  {
    "name": "Pyramid",
    "slug": "pyramid",
    "firstLetter": "P"
  },
  {
    "name": "Q-See",
    "slug": "q-see",
    "firstLetter": "Q"
  },
  {
    "name": "QCY",
    "slug": "qcy",
    "firstLetter": "Q"
  },
  {
    "name": "Qnap",
    "slug": "qnap",
    "firstLetter": "Q"
  },
  {
    "name": "QSHY",
    "slug": "qshy",
    "firstLetter": "Q"
  },
  {
    "name": "Quanta",
    "slug": "quanta",
    "firstLetter": "Q"
  },
  {
    "name": "Quest",
    "slug": "quest",
    "firstLetter": "Q"
  },
  {
    "name": "Quiksilver",
    "slug": "quiksilver",
    "firstLetter": "Q"
  },
  {
    "name": "Quinta de Jugais",
    "slug": "quinta-de-jugais",
    "firstLetter": "Q"
  },
  {
    "name": "Quorum",
    "slug": "quorum",
    "firstLetter": "Q"
  },
  {
    "name": "Qylar",
    "slug": "qylar",
    "firstLetter": "Q"
  },
  {
    "name": "QZSD",
    "slug": "qzsd",
    "firstLetter": "Q"
  },
  {
    "name": "R8",
    "slug": "r8",
    "firstLetter": "R"
  },
  {
    "name": "Ralph Lauren",
    "slug": "ralph-lauren",
    "firstLetter": "R"
  },
  {
    "name": "Ramirez",
    "slug": "ramirez",
    "firstLetter": "R"
  },
  {
    "name": "Ranchitos",
    "slug": "ranchitos",
    "firstLetter": "R"
  },
  {
    "name": "RandM",
    "slug": "randm",
    "firstLetter": "R"
  },
  {
    "name": "Rapala",
    "slug": "rapala",
    "firstLetter": "R"
  },
  {
    "name": "Rapoo",
    "slug": "rapoo",
    "firstLetter": "R"
  },
  {
    "name": "Raquis",
    "slug": "raquis",
    "firstLetter": "R"
  },
  {
    "name": "Rasasi",
    "slug": "rasasi",
    "firstLetter": "R"
  },
  {
    "name": "Rave Bar",
    "slug": "rave-bar",
    "firstLetter": "R"
  },
  {
    "name": "Ray-Ban",
    "slug": "ray-ban",
    "firstLetter": "R"
  },
  {
    "name": "Rayhaan",
    "slug": "rayhaan",
    "firstLetter": "R"
  },
  {
    "name": "Raymond Huet",
    "slug": "raymond-huet",
    "firstLetter": "R"
  },
  {
    "name": "Rayovac",
    "slug": "rayovac",
    "firstLetter": "R"
  },
  {
    "name": "Razer",
    "slug": "razer",
    "firstLetter": "R"
  },
  {
    "name": "RCA",
    "slug": "rca",
    "firstLetter": "R"
  },
  {
    "name": "Real Time",
    "slug": "real-time",
    "firstLetter": "R"
  },
  {
    "name": "Realme",
    "slug": "realme",
    "firstLetter": "R"
  },
  {
    "name": "Realtek",
    "slug": "realtek",
    "firstLetter": "R"
  },
  {
    "name": "Rebul",
    "slug": "rebul",
    "firstLetter": "R"
  },
  {
    "name": "Red",
    "slug": "red",
    "firstLetter": "R"
  },
  {
    "name": "Red Bull",
    "slug": "red-bull",
    "firstLetter": "R"
  },
  {
    "name": "Redragon",
    "slug": "redragon",
    "firstLetter": "R"
  },
  {
    "name": "Reebok",
    "slug": "reebok",
    "firstLetter": "R"
  },
  {
    "name": "Reef",
    "slug": "reef",
    "firstLetter": "R"
  },
  {
    "name": "Renato Balestra",
    "slug": "renato-balestra",
    "firstLetter": "R"
  },
  {
    "name": "Replay",
    "slug": "replay",
    "firstLetter": "R"
  },
  {
    "name": "Revlon",
    "slug": "revlon",
    "firstLetter": "R"
  },
  {
    "name": "Rexona",
    "slug": "rexona",
    "firstLetter": "R"
  },
  {
    "name": "Reyane Tradition",
    "slug": "reyane-tradition",
    "firstLetter": "R"
  },
  {
    "name": "Richmond",
    "slug": "richmond",
    "firstLetter": "R"
  },
  {
    "name": "Ricoh",
    "slug": "ricoh",
    "firstLetter": "R"
  },
  {
    "name": "Ridata",
    "slug": "ridata",
    "firstLetter": "R"
  },
  {
    "name": "Rihanna",
    "slug": "rihanna",
    "firstLetter": "R"
  },
  {
    "name": "Riiffs",
    "slug": "riiffs",
    "firstLetter": "R"
  },
  {
    "name": "Rincoe",
    "slug": "rincoe",
    "firstLetter": "R"
  },
  {
    "name": "RingConn",
    "slug": "ringconn",
    "firstLetter": "R"
  },
  {
    "name": "RioBar",
    "slug": "riobar",
    "firstLetter": "R"
  },
  {
    "name": "Risala",
    "slug": "risala",
    "firstLetter": "R"
  },
  {
    "name": "River Sports",
    "slug": "river-sports",
    "firstLetter": "R"
  },
  {
    "name": "Rívolí",
    "slug": "rivoli",
    "firstLetter": "R"
  },
  {
    "name": "Roadstar",
    "slug": "roadstar",
    "firstLetter": "R"
  },
  {
    "name": "Robert Mondavi",
    "slug": "robert-mondavi",
    "firstLetter": "R"
  },
  {
    "name": "Roberto Capucci",
    "slug": "roberto-capucci",
    "firstLetter": "R"
  },
  {
    "name": "Roberto Cavalli",
    "slug": "roberto-cavalli",
    "firstLetter": "R"
  },
  {
    "name": "Roborock",
    "slug": "roborock",
    "firstLetter": "R"
  },
  {
    "name": "Roccobarocco",
    "slug": "roccobarocco",
    "firstLetter": "R"
  },
  {
    "name": "Rochas",
    "slug": "rochas",
    "firstLetter": "R"
  },
  {
    "name": "Rock's",
    "slug": "rocks",
    "firstLetter": "R"
  },
  {
    "name": "Rockford Fosgate",
    "slug": "rockford-fosgate",
    "firstLetter": "R"
  },
  {
    "name": "Rodicar",
    "slug": "rodicar",
    "firstLetter": "R"
  },
  {
    "name": "Roku",
    "slug": "roku",
    "firstLetter": "R"
  },
  {
    "name": "Roland",
    "slug": "roland",
    "firstLetter": "R"
  },
  {
    "name": "Rossi D'Asiago",
    "slug": "rossi-dasiago",
    "firstLetter": "R"
  },
  {
    "name": "Royal",
    "slug": "royal",
    "firstLetter": "R"
  },
  {
    "name": "Royal Opera",
    "slug": "royal-opera",
    "firstLetter": "R"
  },
  {
    "name": "Royal Salute",
    "slug": "royal-salute",
    "firstLetter": "R"
  },
  {
    "name": "Rue Pergolese",
    "slug": "rue-pergolese",
    "firstLetter": "R"
  },
  {
    "name": "Ruffino",
    "slug": "ruffino",
    "firstLetter": "R"
  },
  {
    "name": "Rummo",
    "slug": "rummo",
    "firstLetter": "R"
  },
  {
    "name": "Rusty",
    "slug": "rusty",
    "firstLetter": "R"
  },
  {
    "name": "Rutini",
    "slug": "rutini",
    "firstLetter": "R"
  },
  {
    "name": "Sony",
    "slug": "sony",
    "firstLetter": "S"
  },
  {
    "name": "S.T.Dupont",
    "slug": "stdupont",
    "firstLetter": "S"
  },
  {
    "name": "S3+",
    "slug": "s3",
    "firstLetter": "S"
  },
  {
    "name": "Sabrina Carpenter",
    "slug": "sabrina-carpenter",
    "firstLetter": "S"
  },
  {
    "name": "Sahari",
    "slug": "sahari",
    "firstLetter": "S"
  },
  {
    "name": "Saint Felicien",
    "slug": "saint-felicien",
    "firstLetter": "S"
  },
  {
    "name": "Saint-Gottard",
    "slug": "saint-gottard",
    "firstLetter": "S"
  },
  {
    "name": "Sally Hansen",
    "slug": "sally-hansen",
    "firstLetter": "S"
  },
  {
    "name": "Salvador Dali",
    "slug": "salvador-dali",
    "firstLetter": "S"
  },
  {
    "name": "Salvatore Ferragamo",
    "slug": "salvatore-ferragamo",
    "firstLetter": "S"
  },
  {
    "name": "Samyang",
    "slug": "samyang",
    "firstLetter": "S"
  },
  {
    "name": "San Pedro",
    "slug": "san-pedro",
    "firstLetter": "S"
  },
  {
    "name": "Sandisk",
    "slug": "sandisk",
    "firstLetter": "S"
  },
  {
    "name": "Santa Alicia",
    "slug": "santa-alicia",
    "firstLetter": "S"
  },
  {
    "name": "Santa Carolina",
    "slug": "santa-carolina",
    "firstLetter": "S"
  },
  {
    "name": "Santa Helena",
    "slug": "santa-helena",
    "firstLetter": "S"
  },
  {
    "name": "Santa Julia",
    "slug": "santa-julia",
    "firstLetter": "S"
  },
  {
    "name": "Santa Rita",
    "slug": "santa-rita",
    "firstLetter": "S"
  },
  {
    "name": "Santisima Trinidad",
    "slug": "santisima-trinidad",
    "firstLetter": "S"
  },
  {
    "name": "Sanyo",
    "slug": "sanyo",
    "firstLetter": "S"
  },
  {
    "name": "Sapori Antichi",
    "slug": "sapori-antichi",
    "firstLetter": "S"
  },
  {
    "name": "Sapphire",
    "slug": "sapphire",
    "firstLetter": "S"
  },
  {
    "name": "Sarah Jessica Parker",
    "slug": "sarah-jessica-parker",
    "firstLetter": "S"
  },
  {
    "name": "Satbox",
    "slug": "satbox",
    "firstLetter": "S"
  },
  {
    "name": "Satechi",
    "slug": "satechi",
    "firstLetter": "S"
  },
  {
    "name": "Satellite",
    "slug": "satellite",
    "firstLetter": "S"
  },
  {
    "name": "Scentology",
    "slug": "scentology",
    "firstLetter": "S"
  },
  {
    "name": "Sceptre",
    "slug": "sceptre",
    "firstLetter": "S"
  },
  {
    "name": "Schwartzhog",
    "slug": "schwartzhog",
    "firstLetter": "S"
  },
  {
    "name": "Schwarzkopf",
    "slug": "schwarzkopf",
    "firstLetter": "S"
  },
  {
    "name": "Scorpion",
    "slug": "scorpion",
    "firstLetter": "S"
  },
  {
    "name": "Scott",
    "slug": "scott",
    "firstLetter": "S"
  },
  {
    "name": "Scottish Leader",
    "slug": "scottish-leader",
    "firstLetter": "S"
  },
  {
    "name": "Seagate",
    "slug": "seagate",
    "firstLetter": "S"
  },
  {
    "name": "Sebastian",
    "slug": "sebastian",
    "firstLetter": "S"
  },
  {
    "name": "Seetec",
    "slug": "seetec",
    "firstLetter": "S"
  },
  {
    "name": "Seetronic",
    "slug": "seetronic",
    "firstLetter": "S"
  },
  {
    "name": "Seiko",
    "slug": "seiko",
    "firstLetter": "S"
  },
  {
    "name": "Selenium",
    "slug": "selenium",
    "firstLetter": "S"
  },
  {
    "name": "Selky",
    "slug": "selky",
    "firstLetter": "S"
  },
  {
    "name": "Semaglix",
    "slug": "semaglix",
    "firstLetter": "S"
  },
  {
    "name": "Sennheiser",
    "slug": "sennheiser",
    "firstLetter": "S"
  },
  {
    "name": "Senscience",
    "slug": "senscience",
    "firstLetter": "S"
  },
  {
    "name": "Sergio Tacchini",
    "slug": "sergio-tacchini",
    "firstLetter": "S"
  },
  {
    "name": "Serpis",
    "slug": "serpis",
    "firstLetter": "S"
  },
  {
    "name": "Sex Addict",
    "slug": "sex-addict",
    "firstLetter": "S"
  },
  {
    "name": "Sexy Hair",
    "slug": "sexy-hair",
    "firstLetter": "S"
  },
  {
    "name": "Shakira",
    "slug": "shakira",
    "firstLetter": "S"
  },
  {
    "name": "Shamsonic",
    "slug": "shamsonic",
    "firstLetter": "S"
  },
  {
    "name": "Shark",
    "slug": "shark",
    "firstLetter": "S"
  },
  {
    "name": "Sharp",
    "slug": "sharp",
    "firstLetter": "S"
  },
  {
    "name": "Sheridan's",
    "slug": "sheridans",
    "firstLetter": "S"
  },
  {
    "name": "Shimano",
    "slug": "shimano",
    "firstLetter": "S"
  },
  {
    "name": "Shirley May Deluxe",
    "slug": "shirley-may-deluxe",
    "firstLetter": "S"
  },
  {
    "name": "Shiseido",
    "slug": "shiseido",
    "firstLetter": "S"
  },
  {
    "name": "Shoei",
    "slug": "shoei",
    "firstLetter": "S"
  },
  {
    "name": "Shokz",
    "slug": "shokz",
    "firstLetter": "S"
  },
  {
    "name": "Show TV",
    "slug": "show-tv",
    "firstLetter": "S"
  },
  {
    "name": "Showbox",
    "slug": "showbox",
    "firstLetter": "S"
  },
  {
    "name": "Shure",
    "slug": "shure",
    "firstLetter": "S"
  },
  {
    "name": "Siberian",
    "slug": "siberian",
    "firstLetter": "S"
  },
  {
    "name": "Sieco",
    "slug": "sieco",
    "firstLetter": "S"
  },
  {
    "name": "Siera",
    "slug": "siera",
    "firstLetter": "S"
  },
  {
    "name": "Sierra",
    "slug": "sierra",
    "firstLetter": "S"
  },
  {
    "name": "Sigma",
    "slug": "sigma",
    "firstLetter": "S"
  },
  {
    "name": "Silicon Mix",
    "slug": "silicon-mix",
    "firstLetter": "S"
  },
  {
    "name": "Silicon Power",
    "slug": "silicon-power",
    "firstLetter": "S"
  },
  {
    "name": "Silk",
    "slug": "silk",
    "firstLetter": "S"
  },
  {
    "name": "Silverstone",
    "slug": "silverstone",
    "firstLetter": "S"
  },
  {
    "name": "Simmons",
    "slug": "simmons",
    "firstLetter": "S"
  },
  {
    "name": "Sir Edward's",
    "slug": "sir-edwards",
    "firstLetter": "S"
  },
  {
    "name": "Sirui",
    "slug": "sirui",
    "firstLetter": "S"
  },
  {
    "name": "Sistelle Paris",
    "slug": "sistelle-paris",
    "firstLetter": "S"
  },
  {
    "name": "Siux",
    "slug": "siux",
    "firstLetter": "S"
  },
  {
    "name": "Sixer",
    "slug": "sixer",
    "firstLetter": "S"
  },
  {
    "name": "SJCAM",
    "slug": "sjcam",
    "firstLetter": "S"
  },
  {
    "name": "SJGAM",
    "slug": "sjgam",
    "firstLetter": "S"
  },
  {
    "name": "SK Hynix",
    "slug": "sk-hynix",
    "firstLetter": "S"
  },
  {
    "name": "Skagen",
    "slug": "skagen",
    "firstLetter": "S"
  },
  {
    "name": "Skechers",
    "slug": "skechers",
    "firstLetter": "S"
  },
  {
    "name": "SKIN1004",
    "slug": "skin1004",
    "firstLetter": "S"
  },
  {
    "name": "Skittles",
    "slug": "skittles",
    "firstLetter": "S"
  },
  {
    "name": "Skmei",
    "slug": "skmei",
    "firstLetter": "S"
  },
  {
    "name": "SKP Pro Audio",
    "slug": "skp-pro-audio",
    "firstLetter": "S"
  },
  {
    "name": "Skullcandy",
    "slug": "skullcandy",
    "firstLetter": "S"
  },
  {
    "name": "Sky Devices",
    "slug": "sky-devices",
    "firstLetter": "S"
  },
  {
    "name": "Skybox",
    "slug": "skybox",
    "firstLetter": "S"
  },
  {
    "name": "SKYY",
    "slug": "skyy",
    "firstLetter": "S"
  },
  {
    "name": "Slapple",
    "slug": "slapple",
    "firstLetter": "S"
  },
  {
    "name": "Smart Vision",
    "slug": "smart-vision",
    "firstLetter": "S"
  },
  {
    "name": "Smart Wheel",
    "slug": "smart-wheel",
    "firstLetter": "S"
  },
  {
    "name": "Smartfy",
    "slug": "smartfy",
    "firstLetter": "S"
  },
  {
    "name": "Smiling Shark",
    "slug": "smiling-shark",
    "firstLetter": "S"
  },
  {
    "name": "Smirnoff",
    "slug": "smirnoff",
    "firstLetter": "S"
  },
  {
    "name": "Smok",
    "slug": "smok",
    "firstLetter": "S"
  },
  {
    "name": "Smucker's",
    "slug": "smuckers",
    "firstLetter": "S"
  },
  {
    "name": "Snowwolf",
    "slug": "snowwolf",
    "firstLetter": "S"
  },
  {
    "name": "Soalheiro",
    "slug": "soalheiro",
    "firstLetter": "S"
  },
  {
    "name": "Sobieski",
    "slug": "sobieski",
    "firstLetter": "S"
  },
  {
    "name": "Solace",
    "slug": "solace",
    "firstLetter": "S"
  },
  {
    "name": "Sonaki",
    "slug": "sonaki",
    "firstLetter": "S"
  },
  {
    "name": "Sonicview",
    "slug": "sonicview",
    "firstLetter": "S"
  },
  {
    "name": "Sonifer",
    "slug": "sonifer",
    "firstLetter": "S"
  },
  {
    "name": "Sonoff",
    "slug": "sonoff",
    "firstLetter": "S"
  },
  {
    "name": "Sorgin",
    "slug": "sorgin",
    "firstLetter": "S"
  },
  {
    "name": "Sorvella",
    "slug": "sorvella",
    "firstLetter": "S"
  },
  {
    "name": "Sospiro",
    "slug": "sospiro",
    "firstLetter": "S"
  },
  {
    "name": "SounDigital",
    "slug": "soundigital",
    "firstLetter": "S"
  },
  {
    "name": "Soundpeats",
    "slug": "soundpeats",
    "firstLetter": "S"
  },
  {
    "name": "Soyo",
    "slug": "soyo",
    "firstLetter": "S"
  },
  {
    "name": "Speed",
    "slug": "speed",
    "firstLetter": "S"
  },
  {
    "name": "Spigen",
    "slug": "spigen",
    "firstLetter": "S"
  },
  {
    "name": "Spirit Of Kings",
    "slug": "spirit-of-kings",
    "firstLetter": "S"
  },
  {
    "name": "SportBox",
    "slug": "sportbox",
    "firstLetter": "S"
  },
  {
    "name": "St. Dalfour",
    "slug": "st-dalfour",
    "firstLetter": "S"
  },
  {
    "name": "St. Ives",
    "slug": "st-ives",
    "firstLetter": "S"
  },
  {
    "name": "Stabilo",
    "slug": "stabilo",
    "firstLetter": "S"
  },
  {
    "name": "Staedtler",
    "slug": "staedtler",
    "firstLetter": "S"
  },
  {
    "name": "Stand Alone",
    "slug": "stand-alone",
    "firstLetter": "S"
  },
  {
    "name": "Stanley",
    "slug": "stanley",
    "firstLetter": "S"
  },
  {
    "name": "Star",
    "slug": "star",
    "firstLetter": "S"
  },
  {
    "name": "Star Hoverboard",
    "slug": "star-hoverboard",
    "firstLetter": "S"
  },
  {
    "name": "Stark",
    "slug": "stark",
    "firstLetter": "S"
  },
  {
    "name": "Starlink",
    "slug": "starlink",
    "firstLetter": "S"
  },
  {
    "name": "Steelseries",
    "slug": "steelseries",
    "firstLetter": "S"
  },
  {
    "name": "Stella Artois",
    "slug": "stella-artois",
    "firstLetter": "S"
  },
  {
    "name": "Stella Dustin",
    "slug": "stella-dustin",
    "firstLetter": "S"
  },
  {
    "name": "Stetsom",
    "slug": "stetsom",
    "firstLetter": "S"
  },
  {
    "name": "Stolichnaya",
    "slug": "stolichnaya",
    "firstLetter": "S"
  },
  {
    "name": "Strega",
    "slug": "strega",
    "firstLetter": "S"
  },
  {
    "name": "STV",
    "slug": "stv",
    "firstLetter": "S"
  },
  {
    "name": "Style & Scents",
    "slug": "style-scents",
    "firstLetter": "S"
  },
  {
    "name": "Suavinex",
    "slug": "suavinex",
    "firstLetter": "S"
  },
  {
    "name": "Suggar",
    "slug": "suggar",
    "firstLetter": "S"
  },
  {
    "name": "Sumax",
    "slug": "sumax",
    "firstLetter": "S"
  },
  {
    "name": "Sundance",
    "slug": "sundance",
    "firstLetter": "S"
  },
  {
    "name": "Sundown",
    "slug": "sundown",
    "firstLetter": "S"
  },
  {
    "name": "Sunmi",
    "slug": "sunmi",
    "firstLetter": "S"
  },
  {
    "name": "Suorin",
    "slug": "suorin",
    "firstLetter": "S"
  },
  {
    "name": "Sup",
    "slug": "sup",
    "firstLetter": "S"
  },
  {
    "name": "Super Hair Dryer",
    "slug": "super-hair-dryer",
    "firstLetter": "S"
  },
  {
    "name": "SuperBox",
    "slug": "superbox",
    "firstLetter": "S"
  },
  {
    "name": "SuperSonic",
    "slug": "supersonic",
    "firstLetter": "S"
  },
  {
    "name": "SuperTV",
    "slug": "supertv",
    "firstLetter": "S"
  },
  {
    "name": "Supreme",
    "slug": "supreme",
    "firstLetter": "S"
  },
  {
    "name": "Suunto",
    "slug": "suunto",
    "firstLetter": "S"
  },
  {
    "name": "Suzuki",
    "slug": "suzuki",
    "firstLetter": "S"
  },
  {
    "name": "Swatch",
    "slug": "swatch",
    "firstLetter": "S"
  },
  {
    "name": "Swiss Arabian",
    "slug": "swiss-arabian",
    "firstLetter": "S"
  },
  {
    "name": "Swiss Dream",
    "slug": "swiss-dream",
    "firstLetter": "S"
  },
  {
    "name": "Swiss Gear",
    "slug": "swiss-gear",
    "firstLetter": "S"
  },
  {
    "name": "Syma",
    "slug": "syma",
    "firstLetter": "S"
  },
  {
    "name": "Symbol",
    "slug": "symbol",
    "firstLetter": "S"
  },
  {
    "name": "Synedica",
    "slug": "synedica",
    "firstLetter": "S"
  },
  {
    "name": "Synology",
    "slug": "synology",
    "firstLetter": "S"
  },
  {
    "name": "T-Dagger",
    "slug": "t-dagger",
    "firstLetter": "T"
  },
  {
    "name": "T.G.",
    "slug": "tg",
    "firstLetter": "T"
  },
  {
    "name": "Tabasco",
    "slug": "tabasco",
    "firstLetter": "T"
  },
  {
    "name": "Tagima",
    "slug": "tagima",
    "firstLetter": "T"
  },
  {
    "name": "Taiff",
    "slug": "taiff",
    "firstLetter": "T"
  },
  {
    "name": "Tailg",
    "slug": "tailg",
    "firstLetter": "T"
  },
  {
    "name": "Taittinger",
    "slug": "taittinger",
    "firstLetter": "T"
  },
  {
    "name": "Takamine",
    "slug": "takamine",
    "firstLetter": "T"
  },
  {
    "name": "Takeya",
    "slug": "takeya",
    "firstLetter": "T"
  },
  {
    "name": "Talisker",
    "slug": "talisker",
    "firstLetter": "T"
  },
  {
    "name": "Tamron",
    "slug": "tamron",
    "firstLetter": "T"
  },
  {
    "name": "Tanqueray",
    "slug": "tanqueray",
    "firstLetter": "T"
  },
  {
    "name": "Taramps",
    "slug": "taramps",
    "firstLetter": "T"
  },
  {
    "name": "Tarapaca",
    "slug": "tarapaca",
    "firstLetter": "T"
  },
  {
    "name": "Targus",
    "slug": "targus",
    "firstLetter": "T"
  },
  {
    "name": "Tasco",
    "slug": "tasco",
    "firstLetter": "T"
  },
  {
    "name": "Tatakua",
    "slug": "tatakua",
    "firstLetter": "T"
  },
  {
    "name": "Tayas",
    "slug": "tayas",
    "firstLetter": "T"
  },
  {
    "name": "Taylor",
    "slug": "taylor",
    "firstLetter": "T"
  },
  {
    "name": "Taylor Swift",
    "slug": "taylor-swift",
    "firstLetter": "T"
  },
  {
    "name": "TCB",
    "slug": "tcb",
    "firstLetter": "T"
  },
  {
    "name": "TCL",
    "slug": "tcl",
    "firstLetter": "T"
  },
  {
    "name": "Teac",
    "slug": "teac",
    "firstLetter": "T"
  },
  {
    "name": "Team Group",
    "slug": "team-group",
    "firstLetter": "T"
  },
  {
    "name": "TEC",
    "slug": "tec",
    "firstLetter": "T"
  },
  {
    "name": "Tecno",
    "slug": "tecno",
    "firstLetter": "T"
  },
  {
    "name": "Ted Lapidus",
    "slug": "ted-lapidus",
    "firstLetter": "T"
  },
  {
    "name": "Tek",
    "slug": "tek",
    "firstLetter": "T"
  },
  {
    "name": "Tentazione",
    "slug": "tentazione",
    "firstLetter": "T"
  },
  {
    "name": "Tequilero Del Leste",
    "slug": "tequilero-del-leste",
    "firstLetter": "T"
  },
  {
    "name": "Teresa Del Castillo",
    "slug": "teresa-del-castillo",
    "firstLetter": "T"
  },
  {
    "name": "Teros",
    "slug": "teros",
    "firstLetter": "T"
  },
  {
    "name": "Terrano",
    "slug": "terrano",
    "firstLetter": "T"
  },
  {
    "name": "Terranoble",
    "slug": "terranoble",
    "firstLetter": "T"
  },
  {
    "name": "Tesla",
    "slug": "tesla",
    "firstLetter": "T"
  },
  {
    "name": "Teslacigs",
    "slug": "teslacigs",
    "firstLetter": "T"
  },
  {
    "name": "Teucer",
    "slug": "teucer",
    "firstLetter": "T"
  },
  {
    "name": "Thameen",
    "slug": "thameen",
    "firstLetter": "T"
  },
  {
    "name": "The Black Sheep",
    "slug": "the-black-sheep",
    "firstLetter": "T"
  },
  {
    "name": "The Botanist",
    "slug": "the-botanist",
    "firstLetter": "T"
  },
  {
    "name": "The Dalmore",
    "slug": "the-dalmore",
    "firstLetter": "T"
  },
  {
    "name": "The Famous Grouse",
    "slug": "the-famous-grouse",
    "firstLetter": "T"
  },
  {
    "name": "The Macallan",
    "slug": "the-macallan",
    "firstLetter": "T"
  },
  {
    "name": "The Merchant Of Venice",
    "slug": "the-merchant-of-venice",
    "firstLetter": "T"
  },
  {
    "name": "The Vitamin Shoppe",
    "slug": "the-vitamin-shoppe",
    "firstLetter": "T"
  },
  {
    "name": "The Voice",
    "slug": "the-voice",
    "firstLetter": "T"
  },
  {
    "name": "Thermalright",
    "slug": "thermalright",
    "firstLetter": "T"
  },
  {
    "name": "Thermaltake",
    "slug": "thermaltake",
    "firstLetter": "T"
  },
  {
    "name": "Thierry Mugler",
    "slug": "thierry-mugler",
    "firstLetter": "T"
  },
  {
    "name": "Thoq Al Hawamer",
    "slug": "thoq-al-hawamer",
    "firstLetter": "T"
  },
  {
    "name": "Thronmax",
    "slug": "thronmax",
    "firstLetter": "T"
  },
  {
    "name": "Thrustmaster",
    "slug": "thrustmaster",
    "firstLetter": "T"
  },
  {
    "name": "Thule",
    "slug": "thule",
    "firstLetter": "T"
  },
  {
    "name": "Tia Helena",
    "slug": "tia-helena",
    "firstLetter": "T"
  },
  {
    "name": "Tiburon",
    "slug": "tiburon",
    "firstLetter": "T"
  },
  {
    "name": "Tic Tac",
    "slug": "tic-tac",
    "firstLetter": "T"
  },
  {
    "name": "Tiffany & Co.",
    "slug": "tiffany-co",
    "firstLetter": "T"
  },
  {
    "name": "Tigre",
    "slug": "tigre",
    "firstLetter": "T"
  },
  {
    "name": "TigreCook",
    "slug": "tigrecook",
    "firstLetter": "T"
  },
  {
    "name": "Tilibra",
    "slug": "tilibra",
    "firstLetter": "T"
  },
  {
    "name": "Timberland",
    "slug": "timberland",
    "firstLetter": "T"
  },
  {
    "name": "Timex",
    "slug": "timex",
    "firstLetter": "T"
  },
  {
    "name": "Tineco",
    "slug": "tineco",
    "firstLetter": "T"
  },
  {
    "name": "Tirzec",
    "slug": "tirzec",
    "firstLetter": "T"
  },
  {
    "name": "Tirzedral",
    "slug": "tirzedral",
    "firstLetter": "T"
  },
  {
    "name": "Tiscaz",
    "slug": "tiscaz",
    "firstLetter": "T"
  },
  {
    "name": "Tissot",
    "slug": "tissot",
    "firstLetter": "T"
  },
  {
    "name": "Titan",
    "slug": "titan",
    "firstLetter": "T"
  },
  {
    "name": "Tiziano Bonini",
    "slug": "tiziano-bonini",
    "firstLetter": "T"
  },
  {
    "name": "TKS",
    "slug": "tks",
    "firstLetter": "T"
  },
  {
    "name": "Toblerone",
    "slug": "toblerone",
    "firstLetter": "T"
  },
  {
    "name": "Tocomlink",
    "slug": "tocomlink",
    "firstLetter": "T"
  },
  {
    "name": "Tocomsat",
    "slug": "tocomsat",
    "firstLetter": "T"
  },
  {
    "name": "Tofia",
    "slug": "tofia",
    "firstLetter": "T"
  },
  {
    "name": "Tokina",
    "slug": "tokina",
    "firstLetter": "T"
  },
  {
    "name": "Tolón-Tolón",
    "slug": "tolon-tolon",
    "firstLetter": "T"
  },
  {
    "name": "Tom Ford",
    "slug": "tom-ford",
    "firstLetter": "T"
  },
  {
    "name": "Tommy Hilfiger",
    "slug": "tommy-hilfiger",
    "firstLetter": "T"
  },
  {
    "name": "TomTom",
    "slug": "tomtom",
    "firstLetter": "T"
  },
  {
    "name": "Tonino Lamborghini",
    "slug": "tonino-lamborghini",
    "firstLetter": "T"
  },
  {
    "name": "Top Fishing",
    "slug": "top-fishing",
    "firstLetter": "T"
  },
  {
    "name": "Top TV",
    "slug": "top-tv",
    "firstLetter": "T"
  },
  {
    "name": "Tora Bika",
    "slug": "tora-bika",
    "firstLetter": "T"
  },
  {
    "name": "Tornado",
    "slug": "tornado",
    "firstLetter": "T"
  },
  {
    "name": "Tory Burch",
    "slug": "tory-burch",
    "firstLetter": "T"
  },
  {
    "name": "Toshiba",
    "slug": "toshiba",
    "firstLetter": "T"
  },
  {
    "name": "Total",
    "slug": "total",
    "firstLetter": "T"
  },
  {
    "name": "TotoLink",
    "slug": "totolink",
    "firstLetter": "T"
  },
  {
    "name": "Tough Master",
    "slug": "tough-master",
    "firstLetter": "T"
  },
  {
    "name": "Tourobox",
    "slug": "tourobox",
    "firstLetter": "T"
  },
  {
    "name": "Tourosat",
    "slug": "tourosat",
    "firstLetter": "T"
  },
  {
    "name": "Tous",
    "slug": "tous",
    "firstLetter": "T"
  },
  {
    "name": "Tovaritch",
    "slug": "tovaritch",
    "firstLetter": "T"
  },
  {
    "name": "TP-Link",
    "slug": "tp-link",
    "firstLetter": "T"
  },
  {
    "name": "Tramontina",
    "slug": "tramontina",
    "firstLetter": "T"
  },
  {
    "name": "Transcend",
    "slug": "transcend",
    "firstLetter": "T"
  },
  {
    "name": "Trapiche",
    "slug": "trapiche",
    "firstLetter": "T"
  },
  {
    "name": "Traversa",
    "slug": "traversa",
    "firstLetter": "T"
  },
  {
    "name": "Tree Hut",
    "slug": "tree-hut",
    "firstLetter": "T"
  },
  {
    "name": "Tres Plumas",
    "slug": "tres-plumas",
    "firstLetter": "T"
  },
  {
    "name": "Treseme",
    "slug": "treseme",
    "firstLetter": "T"
  },
  {
    "name": "Trident",
    "slug": "trident",
    "firstLetter": "T"
  },
  {
    "name": "Trim",
    "slug": "trim",
    "firstLetter": "T"
  },
  {
    "name": "Trimui",
    "slug": "trimui",
    "firstLetter": "T"
  },
  {
    "name": "Tronsmart",
    "slug": "tronsmart",
    "firstLetter": "T"
  },
  {
    "name": "Truly",
    "slug": "truly",
    "firstLetter": "T"
  },
  {
    "name": "Truper",
    "slug": "truper",
    "firstLetter": "T"
  },
  {
    "name": "Truss",
    "slug": "truss",
    "firstLetter": "T"
  },
  {
    "name": "Trussardi",
    "slug": "trussardi",
    "firstLetter": "T"
  },
  {
    "name": "Tryx",
    "slug": "tryx",
    "firstLetter": "T"
  },
  {
    "name": "Tsubaki",
    "slug": "tsubaki",
    "firstLetter": "T"
  },
  {
    "name": "Tucano",
    "slug": "tucano",
    "firstLetter": "T"
  },
  {
    "name": "Tunas",
    "slug": "tunas",
    "firstLetter": "T"
  },
  {
    "name": "Tuning",
    "slug": "tuning",
    "firstLetter": "T"
  },
  {
    "name": "Turtle Beach",
    "slug": "turtle-beach",
    "firstLetter": "T"
  },
  {
    "name": "Tutto Calabria",
    "slug": "tutto-calabria",
    "firstLetter": "T"
  },
  {
    "name": "TV Box",
    "slug": "tv-box",
    "firstLetter": "T"
  },
  {
    "name": "TVA",
    "slug": "tva",
    "firstLetter": "T"
  },
  {
    "name": "Twinings",
    "slug": "twinings",
    "firstLetter": "T"
  },
  {
    "name": "Tycon",
    "slug": "tycon",
    "firstLetter": "T"
  },
  {
    "name": "Ubiquiti",
    "slug": "ubiquiti",
    "firstLetter": "U"
  },
  {
    "name": "UCC Life",
    "slug": "ucc-life",
    "firstLetter": "U"
  },
  {
    "name": "Udirc",
    "slug": "udirc",
    "firstLetter": "U"
  },
  {
    "name": "Ulanzi",
    "slug": "ulanzi",
    "firstLetter": "U"
  },
  {
    "name": "uleFone",
    "slug": "ulefone",
    "firstLetter": "U"
  },
  {
    "name": "Ulric De Varens",
    "slug": "ulric-de-varens",
    "firstLetter": "U"
  },
  {
    "name": "Ultra Cool",
    "slug": "ultra-cool",
    "firstLetter": "U"
  },
  {
    "name": "Ultrabox",
    "slug": "ultrabox",
    "firstLetter": "U"
  },
  {
    "name": "Umbro",
    "slug": "umbro",
    "firstLetter": "U"
  },
  {
    "name": "Umidigi",
    "slug": "umidigi",
    "firstLetter": "U"
  },
  {
    "name": "Under Armour",
    "slug": "under-armour",
    "firstLetter": "U"
  },
  {
    "name": "Undurraga",
    "slug": "undurraga",
    "firstLetter": "U"
  },
  {
    "name": "Unic",
    "slug": "unic",
    "firstLetter": "U"
  },
  {
    "name": "Uniden",
    "slug": "uniden",
    "firstLetter": "U"
  },
  {
    "name": "Unitech",
    "slug": "unitech",
    "firstLetter": "U"
  },
  {
    "name": "UniTV",
    "slug": "unitv",
    "firstLetter": "U"
  },
  {
    "name": "Universal",
    "slug": "universal",
    "firstLetter": "U"
  },
  {
    "name": "Unnion",
    "slug": "unnion",
    "firstLetter": "U"
  },
  {
    "name": "UP Gamer",
    "slug": "up-gamer",
    "firstLetter": "U"
  },
  {
    "name": "UTV",
    "slug": "utv",
    "firstLetter": "U"
  },
  {
    "name": "Uwell",
    "slug": "uwell",
    "firstLetter": "U"
  },
  {
    "name": "Valdivieso",
    "slug": "valdivieso",
    "firstLetter": "V"
  },
  {
    "name": "Valentino",
    "slug": "valentino",
    "firstLetter": "V"
  },
  {
    "name": "Valor",
    "slug": "valor",
    "firstLetter": "V"
  },
  {
    "name": "Valve",
    "slug": "valve",
    "firstLetter": "V"
  },
  {
    "name": "Van Camp's",
    "slug": "van-camps",
    "firstLetter": "V"
  },
  {
    "name": "Vans",
    "slug": "vans",
    "firstLetter": "V"
  },
  {
    "name": "Vapeman",
    "slug": "vapeman",
    "firstLetter": "V"
  },
  {
    "name": "Vapengin",
    "slug": "vapengin",
    "firstLetter": "V"
  },
  {
    "name": "VapeSoul",
    "slug": "vapesoul",
    "firstLetter": "V"
  },
  {
    "name": "Vapetasia",
    "slug": "vapetasia",
    "firstLetter": "V"
  },
  {
    "name": "Vaporesso",
    "slug": "vaporesso",
    "firstLetter": "V"
  },
  {
    "name": "Vaseline",
    "slug": "vaseline",
    "firstLetter": "V"
  },
  {
    "name": "Vcan",
    "slug": "vcan",
    "firstLetter": "V"
  },
  {
    "name": "Vega",
    "slug": "vega",
    "firstLetter": "V"
  },
  {
    "name": "Velds",
    "slug": "velds",
    "firstLetter": "V"
  },
  {
    "name": "Vemmax",
    "slug": "vemmax",
    "firstLetter": "V"
  },
  {
    "name": "Ventisquero",
    "slug": "ventisquero",
    "firstLetter": "V"
  },
  {
    "name": "Versace",
    "slug": "versace",
    "firstLetter": "V"
  },
  {
    "name": "Vertex",
    "slug": "vertex",
    "firstLetter": "V"
  },
  {
    "name": "Vertiv",
    "slug": "vertiv",
    "firstLetter": "V"
  },
  {
    "name": "Veuve Clicquot",
    "slug": "veuve-clicquot",
    "firstLetter": "V"
  },
  {
    "name": "Vezr",
    "slug": "vezr",
    "firstLetter": "V"
  },
  {
    "name": "Vgod",
    "slug": "vgod",
    "firstLetter": "V"
  },
  {
    "name": "Via Paris",
    "slug": "via-paris",
    "firstLetter": "V"
  },
  {
    "name": "Vichy",
    "slug": "vichy",
    "firstLetter": "V"
  },
  {
    "name": "Victoria's Secret",
    "slug": "victorias-secret",
    "firstLetter": "V"
  },
  {
    "name": "Victorinox",
    "slug": "victorinox",
    "firstLetter": "V"
  },
  {
    "name": "Victorio & Lucchino",
    "slug": "victorio-lucchino",
    "firstLetter": "V"
  },
  {
    "name": "Vidvie",
    "slug": "vidvie",
    "firstLetter": "V"
  },
  {
    "name": "Viewsonic",
    "slug": "viewsonic",
    "firstLetter": "V"
  },
  {
    "name": "Vigilante",
    "slug": "vigilante",
    "firstLetter": "V"
  },
  {
    "name": "Viktor & Rolf",
    "slug": "viktor-rolf",
    "firstLetter": "V"
  },
  {
    "name": "Villa Cardea",
    "slug": "villa-cardea",
    "firstLetter": "V"
  },
  {
    "name": "Villa Massa",
    "slug": "villa-massa",
    "firstLetter": "V"
  },
  {
    "name": "Viltrox",
    "slug": "viltrox",
    "firstLetter": "V"
  },
  {
    "name": "Vina Maipo",
    "slug": "vina-maipo",
    "firstLetter": "V"
  },
  {
    "name": "Vinovalie",
    "slug": "vinovalie",
    "firstLetter": "V"
  },
  {
    "name": "Visionbras",
    "slug": "visionbras",
    "firstLetter": "V"
  },
  {
    "name": "VisionSat",
    "slug": "visionsat",
    "firstLetter": "V"
  },
  {
    "name": "Vital Care",
    "slug": "vital-care",
    "firstLetter": "V"
  },
  {
    "name": "Vivitar",
    "slug": "vivitar",
    "firstLetter": "V"
  },
  {
    "name": "VivoStar",
    "slug": "vivostar",
    "firstLetter": "V"
  },
  {
    "name": "Vizzion",
    "slug": "vizzion",
    "firstLetter": "V"
  },
  {
    "name": "Vogue",
    "slug": "vogue",
    "firstLetter": "V"
  },
  {
    "name": "Volaré",
    "slug": "volare",
    "firstLetter": "V"
  },
  {
    "name": "Volcano",
    "slug": "volcano",
    "firstLetter": "V"
  },
  {
    "name": "Voopoo",
    "slug": "voopoo",
    "firstLetter": "V"
  },
  {
    "name": "Voyager",
    "slug": "voyager",
    "firstLetter": "V"
  },
  {
    "name": "Vozol",
    "slug": "vozol",
    "firstLetter": "V"
  },
  {
    "name": "Vsat",
    "slug": "vsat",
    "firstLetter": "V"
  },
  {
    "name": "VT Cosmetics",
    "slug": "vt-cosmetics",
    "firstLetter": "V"
  },
  {
    "name": "VTV",
    "slug": "vtv",
    "firstLetter": "V"
  },
  {
    "name": "Wacom",
    "slug": "wacom",
    "firstLetter": "W"
  },
  {
    "name": "Wadfow",
    "slug": "wadfow",
    "firstLetter": "W"
  },
  {
    "name": "Wahl",
    "slug": "wahl",
    "firstLetter": "W"
  },
  {
    "name": "Waka",
    "slug": "waka",
    "firstLetter": "W"
  },
  {
    "name": "Wange",
    "slug": "wange",
    "firstLetter": "W"
  },
  {
    "name": "Wanli",
    "slug": "wanli",
    "firstLetter": "W"
  },
  {
    "name": "Warwick",
    "slug": "warwick",
    "firstLetter": "W"
  },
  {
    "name": "Washburn",
    "slug": "washburn",
    "firstLetter": "W"
  },
  {
    "name": "Waterpik",
    "slug": "waterpik",
    "firstLetter": "W"
  },
  {
    "name": "Wavytalk",
    "slug": "wavytalk",
    "firstLetter": "W"
  },
  {
    "name": "Wearfit Pro",
    "slug": "wearfit-pro",
    "firstLetter": "W"
  },
  {
    "name": "Weedoo",
    "slug": "weedoo",
    "firstLetter": "W"
  },
  {
    "name": "Weifeng",
    "slug": "weifeng",
    "firstLetter": "W"
  },
  {
    "name": "Weinrich",
    "slug": "weinrich",
    "firstLetter": "W"
  },
  {
    "name": "Wella",
    "slug": "wella",
    "firstLetter": "W"
  },
  {
    "name": "Western Digital",
    "slug": "western-digital",
    "firstLetter": "W"
  },
  {
    "name": "Westinghouse",
    "slug": "westinghouse",
    "firstLetter": "W"
  },
  {
    "name": "White Horse",
    "slug": "white-horse",
    "firstLetter": "W"
  },
  {
    "name": "Whitley Neill",
    "slug": "whitley-neill",
    "firstLetter": "W"
  },
  {
    "name": "Whyte & Mackay",
    "slug": "whyte-mackay",
    "firstLetter": "W"
  },
  {
    "name": "Wild Turkey",
    "slug": "wild-turkey",
    "firstLetter": "W"
  },
  {
    "name": "William Peel",
    "slug": "william-peel",
    "firstLetter": "W"
  },
  {
    "name": "Wilson",
    "slug": "wilson",
    "firstLetter": "W"
  },
  {
    "name": "Winca",
    "slug": "winca",
    "firstLetter": "W"
  },
  {
    "name": "Winning Star",
    "slug": "winning-star",
    "firstLetter": "W"
  },
  {
    "name": "Wired",
    "slug": "wired",
    "firstLetter": "W"
  },
  {
    "name": "Wismec",
    "slug": "wismec",
    "firstLetter": "W"
  },
  {
    "name": "Wiwu",
    "slug": "wiwu",
    "firstLetter": "W"
  },
  {
    "name": "WLmouse",
    "slug": "wlmouse",
    "firstLetter": "W"
  },
  {
    "name": "WLtoys",
    "slug": "wltoys",
    "firstLetter": "W"
  },
  {
    "name": "Wmark",
    "slug": "wmark",
    "firstLetter": "W"
  },
  {
    "name": "Women Secret",
    "slug": "women-secret",
    "firstLetter": "W"
  },
  {
    "name": "Woodford",
    "slug": "woodford",
    "firstLetter": "W"
  },
  {
    "name": "Wrigley's",
    "slug": "wrigleys",
    "firstLetter": "W"
  },
  {
    "name": "Wubian",
    "slug": "wubian",
    "firstLetter": "W"
  },
  {
    "name": "Wyborowa",
    "slug": "wyborowa",
    "firstLetter": "W"
  },
  {
    "name": "Wybot",
    "slug": "wybot",
    "firstLetter": "W"
  },
  {
    "name": "X-Tech",
    "slug": "x-tech",
    "firstLetter": "X"
  },
  {
    "name": "Xerjoff",
    "slug": "xerjoff",
    "firstLetter": "X"
  },
  {
    "name": "Xerox",
    "slug": "xerox",
    "firstLetter": "X"
  },
  {
    "name": "XFX",
    "slug": "xfx",
    "firstLetter": "X"
  },
  {
    "name": "Xion",
    "slug": "xion",
    "firstLetter": "X"
  },
  {
    "name": "XO",
    "slug": "xo",
    "firstLetter": "X"
  },
  {
    "name": "XP-Pen",
    "slug": "xp-pen",
    "firstLetter": "X"
  },
  {
    "name": "Xplus",
    "slug": "xplus",
    "firstLetter": "X"
  },
  {
    "name": "XS",
    "slug": "xs",
    "firstLetter": "X"
  },
  {
    "name": "Xtreme",
    "slug": "xtreme",
    "firstLetter": "X"
  },
  {
    "name": "Xtrike Me",
    "slug": "xtrike-me",
    "firstLetter": "X"
  },
  {
    "name": "Xuxu",
    "slug": "xuxu",
    "firstLetter": "X"
  },
  {
    "name": "Yaber",
    "slug": "yaber",
    "firstLetter": "Y"
  },
  {
    "name": "Yadea",
    "slug": "yadea",
    "firstLetter": "Y"
  },
  {
    "name": "Yaesu",
    "slug": "yaesu",
    "firstLetter": "Y"
  },
  {
    "name": "Yamaha",
    "slug": "yamaha",
    "firstLetter": "Y"
  },
  {
    "name": "Yeah",
    "slug": "yeah",
    "firstLetter": "Y"
  },
  {
    "name": "Yealink",
    "slug": "yealink",
    "firstLetter": "Y"
  },
  {
    "name": "Yo-Zuri",
    "slug": "yo-zuri",
    "firstLetter": "Y"
  },
  {
    "name": "Yonex",
    "slug": "yonex",
    "firstLetter": "Y"
  },
  {
    "name": "Yongnuo",
    "slug": "yongnuo",
    "firstLetter": "Y"
  },
  {
    "name": "Yookie",
    "slug": "yookie",
    "firstLetter": "Y"
  },
  {
    "name": "Yoop",
    "slug": "yoop",
    "firstLetter": "Y"
  },
  {
    "name": "Yoxy",
    "slug": "yoxy",
    "firstLetter": "Y"
  },
  {
    "name": "Yunmai",
    "slug": "yunmai",
    "firstLetter": "Y"
  },
  {
    "name": "Yuoto",
    "slug": "yuoto",
    "firstLetter": "Y"
  },
  {
    "name": "Yves De Sistelle",
    "slug": "yves-de-sistelle",
    "firstLetter": "Y"
  },
  {
    "name": "Yves Saint Laurent",
    "slug": "yves-saint-laurent",
    "firstLetter": "Y"
  },
  {
    "name": "Zaap TV",
    "slug": "zaap-tv",
    "firstLetter": "Z"
  },
  {
    "name": "Zacapa",
    "slug": "zacapa",
    "firstLetter": "Z"
  },
  {
    "name": "Zakat",
    "slug": "zakat",
    "firstLetter": "Z"
  },
  {
    "name": "Zaros",
    "slug": "zaros",
    "firstLetter": "Z"
  },
  {
    "name": "Zeblaze",
    "slug": "zeblaze",
    "firstLetter": "Z"
  },
  {
    "name": "Zebra",
    "slug": "zebra",
    "firstLetter": "Z"
  },
  {
    "name": "Zernoff",
    "slug": "zernoff",
    "firstLetter": "Z"
  },
  {
    "name": "Zeven",
    "slug": "zeven",
    "firstLetter": "Z"
  },
  {
    "name": "Zhiyun",
    "slug": "zhiyun",
    "firstLetter": "Z"
  },
  {
    "name": "Zildjian",
    "slug": "zildjian",
    "firstLetter": "Z"
  },
  {
    "name": "Zimaya",
    "slug": "zimaya",
    "firstLetter": "Z"
  },
  {
    "name": "Zippo",
    "slug": "zippo",
    "firstLetter": "Z"
  },
  {
    "name": "Zirconia Prive",
    "slug": "zirconia-prive",
    "firstLetter": "Z"
  },
  {
    "name": "ZKTeco",
    "slug": "zkteco",
    "firstLetter": "Z"
  },
  {
    "name": "Zojirushi",
    "slug": "zojirushi",
    "firstLetter": "Z"
  },
  {
    "name": "Zomo",
    "slug": "zomo",
    "firstLetter": "Z"
  },
  {
    "name": "Zonin",
    "slug": "zonin",
    "firstLetter": "Z"
  },
  {
    "name": "Zotac",
    "slug": "zotac",
    "firstLetter": "Z"
  },
  {
    "name": "ZTE",
    "slug": "zte",
    "firstLetter": "Z"
  },
  {
    "name": "Zubrowka",
    "slug": "zubrowka",
    "firstLetter": "Z"
  },
  {
    "name": "Zuccardi",
    "slug": "zuccardi",
    "firstLetter": "Z"
  }
];

export const FEATURED_BRANDS: string[] = [
  "Apple", "Samsung", "Xiaomi", "Sony", "Nintendo", "Microsoft", "JBL", "GoPro",
  "Canon", "Nikon", "DJI", "Asus", "Acer", "Dell", "HP", "Lenovo", "Logitech",
  "Razer", "Corsair", "Kingston", "SanDisk", "Anker", "Baseus", "Pioneer",
  "Lancôme", "Paco Rabanne", "Carolina Herrera", "Dior", "Chanel", "Calvin Klein",
  "Hugo Boss", "Armani", "Versace", "Lattafa", "Brand Collection", "Fragrance World",
  "Stanley", "DeWalt", "Makita", "Bosch", "Bambu Lab", "Creality", "Garmin", "Amazfit"
];
